import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCRoundRobinLeads(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 503.04 352.425">
            <g id="Round_Robin_Leads" transform="translate(-3.57 -76.695)">
                <circle
                    id="Ellipse_1"
                    data-name="Ellipse 1"
                    cx="7.78"
                    cy="7.78"
                    r="7.78"
                    transform="translate(20.54 312.19)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_2"
                    data-name="Ellipse 2"
                    cx="7.78"
                    cy="7.78"
                    r="7.78"
                    transform="translate(242.28 113.09)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_3"
                    data-name="Ellipse 3"
                    cx="10.41"
                    cy="10.41"
                    r="10.41"
                    transform="translate(179.06 85.74)"
                    fill="#fff"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_1"
                    data-name="Path 1"
                    d="M119.42,108.88H113v-6.43a.8.8,0,0,0-.8-.8h0a.82.82,0,0,0-.82.8v6.43h-6.42a.81.81,0,0,0,0,1.62h6.42v6.43a.81.81,0,0,0,.82.8.8.8,0,0,0,.8-.8h0V110.5h6.44a.8.8,0,0,0,.8-.8.82.82,0,0,0-.82-.82Z"
                    fill="#e1e1e1"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_2"
                    data-name="Path 2"
                    d="M388.76,88.08H379V78.29a1.22,1.22,0,0,0-1.22-1.22h0a1.25,1.25,0,0,0-1.25,1.22v9.79h-9.77a1.24,1.24,0,1,0,0,2.47h9.77v9.8a1.25,1.25,0,0,0,1.25,1.22,1.22,1.22,0,0,0,1.22-1.22h0v-9.8h9.8a1.23,1.23,0,0,0,1.2-1.22,1.25,1.25,0,0,0-1.24-1.25Z"
                    fill="#e1e1e1"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_3"
                    data-name="Path 3"
                    d="M450.23,303.9h-9V295a1.11,1.11,0,0,0-1.11-1.11h0A1.14,1.14,0,0,0,439,295v8.94h-8.9a1.13,1.13,0,1,0,0,2.25H439v9a1.15,1.15,0,0,0,1.14,1.12,1.11,1.11,0,0,0,1.11-1.12h0v-9h9a1.13,1.13,0,0,0,0-2.25Z"
                    fill="#e1e1e1"
                    stroke="#e1e1e1"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <ellipse
                    id="_Path_"
                    data-name="&lt;Path&gt;"
                    cx="251.52"
                    cy="29.67"
                    rx="251.52"
                    ry="29.67"
                    transform="translate(3.57 369.78)"
                    fill="#f3f4f5"
                />
                <path
                    id="Path_4"
                    data-name="Path 4"
                    d="M206.65,185.29h0a26.37,26.37,0,0,1-35.83-10.4h0a26.38,26.38,0,0,1,10.4-35.83h0a26.38,26.38,0,0,1,35.83,10.4h0a26.37,26.37,0,0,1-10.4,35.83Z"
                    fill="#fff"
                />
                <path
                    id="Path_5"
                    data-name="Path 5"
                    d="M206.65,185.29l.36-.24,1.06-.67.78-.49c.28-.2.56-.44.88-.68l1-.8a13.97,13.97,0,0,0,1.09-1,25.44,25.44,0,0,0,4.73-5.94,26.34,26.34,0,0,0,3.3-9.44c.07-.46.13-.93.2-1.41s0-.95.07-1.44a5.241,5.241,0,0,0,0-1.48l-.09-1.51v-.77l-.12-.76-.24-1.55c-.1-.52-.26-1-.39-1.56a10.676,10.676,0,0,0-.45-1.56,22.77,22.77,0,0,0-1.26-3.09c-.25-.51-.48-1-.77-1.53s-.6-1-.91-1.48c-.16-.25-.3-.51-.47-.74l-.54-.7c-.37-.47-.71-1-1.1-1.41a28.571,28.571,0,0,0-2.59-2.57,27.6,27.6,0,0,0-3-2.27c-.53-.34-1.1-.64-1.64-1-.28-.16-.55-.34-.84-.47l-.88-.39a28.6,28.6,0,0,0-3.65-1.39,29.6,29.6,0,0,0-3.9-.79l-1-.14h-1l-1-.05a5.788,5.788,0,0,0-1,0l-2.05.11-2,.31a26,26,0,0,0-14.5,8l-1.36,1.56-1.19,1.67-.29.42-.26.44-.5.88-.51.88-.41.91a29.074,29.074,0,0,0-1.43,3.72,30.449,30.449,0,0,0-.78,3.82l-.13,1a5.823,5.823,0,0,1-.06,1c0,.63-.07,1.27-.07,1.9a26.791,26.791,0,0,0,.33,3.72,27.83,27.83,0,0,0,.79,3.56c.17.57.4,1.12.6,1.68l.3.83c.11.28.25.53.37.8.26.52.51,1,.76,1.56a12.154,12.154,0,0,0,.88,1.47,24.65,24.65,0,0,0,1.94,2.72,12.548,12.548,0,0,0,1.08,1.22c.37.39.72.8,1.11,1.16l1.18,1,.58.51.62.45,1.23.88a13.736,13.736,0,0,0,1.27.76c.42.24.84.5,1.26.72l1.29.59a26.2,26.2,0,0,0,9.74,2.26,25.22,25.22,0,0,0,7.54-.81,14.639,14.639,0,0,0,1.43-.39l1.22-.44a8.762,8.762,0,0,0,1-.39l.83-.39,1.14-.54.39-.17s-.12.08-.37.21l-1.13.56-.83.41c-.31.14-.66.26-1,.41l-1.22.45c-.43.18-.93.26-1.43.41a25,25,0,0,1-7.58.88,26.28,26.28,0,0,1-9.84-2.24l-1.31-.58-1.27-.72c-.42-.26-.88-.47-1.28-.77l-1.25-.88-.63-.46-.59-.51-1.2-1c-.39-.36-.74-.78-1.12-1.17a14.253,14.253,0,0,1-1.1-1.22,26.192,26.192,0,0,1-2-2.75c-.29-.49-.62-1-.89-1.48l-.78-1.58c-.12-.27-.27-.53-.37-.81l-.31-.84c-.2-.56-.43-1.12-.61-1.7a28.478,28.478,0,0,1-.81-3.6,29.182,29.182,0,0,1-.34-3.77c0-.64.05-1.28.07-1.92a5.709,5.709,0,0,1,.06-1l.13-1a29.186,29.186,0,0,1,.79-3.87,29.792,29.792,0,0,1,1.44-3.77l.42-.93.51-.89.51-.89.26-.45.29-.42c.41-.56.81-1.13,1.21-1.7l1.38-1.58a26.22,26.22,0,0,1,14.68-8.07l2.07-.32,2.08-.11a7.079,7.079,0,0,1,1,0h2l1,.14a31.748,31.748,0,0,1,4,.8,30.379,30.379,0,0,1,3.7,1.41l.89.41c.29.13.56.31.84.47.56.33,1.13.63,1.67,1a28.612,28.612,0,0,1,3,2.31,27.857,27.857,0,0,1,2.61,2.6c.4.46.75,1,1.12,1.43l.54.71c.18.24.32.5.48.75l.92,1.5c.29.5.51,1,.77,1.55a23.869,23.869,0,0,1,1.27,3.13,14.884,14.884,0,0,1,.45,1.58c.13.53.29,1,.38,1.57l.24,1.57.12.78v.77a9.937,9.937,0,0,0,.08,1.53,14.755,14.755,0,0,1,0,1.49,9.989,9.989,0,0,1-.07,1.46l-.2,1.41a26.17,26.17,0,0,1-3.39,9.51,25.06,25.06,0,0,1-4.79,5.94c-.4.34-.73.72-1.11,1l-1.05.79c-.32.24-.61.48-.89.67l-.8.48-1.07.64A1.8,1.8,0,0,1,206.65,185.29Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_6"
                    data-name="Path 6"
                    d="M195.81,160.83a6.48,6.48,0,0,0,.5-7.11,6.09,6.09,0,1,0-10.68,5.81,6.46,6.46,0,0,0,6.31,3.43c-7.52,5.75-2.25,14.45-2.25,14.45l19.43-10.57S204.61,157.59,195.81,160.83Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M45.67,145.12h0a10.93,10.93,0,0,1-3.86-15h0a10.93,10.93,0,0,1,15-3.85h0a10.92,10.92,0,0,1,3.86,15h0a10.93,10.93,0,0,1-15,3.85Z"
                    fill="#fff"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M45.67,145.12a19.369,19.369,0,0,0,2.49,1,10.17,10.17,0,0,0,3.1.41,10.79,10.79,0,0,0,10.53-8.83,10,10,0,0,0,.12-3.09,14.491,14.491,0,0,0-.27-1.58,12.23,12.23,0,0,0-.54-1.54,10.88,10.88,0,0,0-12.56-6.19,13,13,0,0,0-1.52.52,10.34,10.34,0,0,0-2.64,1.6A10.79,10.79,0,0,0,40.5,137a11,11,0,0,0,1.23,3.93,10.76,10.76,0,0,0,1.86,2.52,18.462,18.462,0,0,0,2.08,1.7l-.16-.09-.44-.27a5.091,5.091,0,0,1-.7-.49,7.85,7.85,0,0,1-.87-.76A10.36,10.36,0,0,1,41.56,141a11.08,11.08,0,0,1-1.3-4,10.88,10.88,0,0,1,.56-5.06,11,11,0,0,1,3.35-4.78,10.54,10.54,0,0,1,2.72-1.66,13.669,13.669,0,0,1,1.56-.54,13.376,13.376,0,0,1,1.66-.28,11,11,0,0,1,11.3,6.66,12,12,0,0,1,.55,1.59,10.489,10.489,0,0,1,.28,1.63,10.3,10.3,0,0,1-.13,3.19,11,11,0,0,1-10.85,9,10.53,10.53,0,0,1-3.14-.48,7.912,7.912,0,0,1-1.09-.4,4.921,4.921,0,0,1-.76-.37l-.45-.26Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M52.1,136.09a2.66,2.66,0,0,0,2.63-1.33,2.52,2.52,0,1,0-4.32-2.57,2.69,2.69,0,0,0,.11,3c-3.63-1.47-5.62,2.25-5.62,2.25l7.86,4.69S55.11,138.54,52.1,136.09Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M479.32,181.39l-36.13,9.03,9.7,8.99-25.13,13.94,42.85-8.58L460.6,195.5Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M313.02,126.17l-7.5,19.27,7.19-1.51-1.75,15.86,9.86-22.17-7.41,1.56Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M73.75,291.13l-23.94-22.4L47.8,280.2,25.48,268.28l26.81,27.58,2.08-11.83Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_13"
                    data-name="Path 13"
                    d="M464.88,369.73a25.9,25.9,0,1,1-31.17-19.25,25.9,25.9,0,0,1,31.17,19.25Z"
                    fill="#717272"
                />
                <g id="Group_1" data-name="Group 1" opacity="0.1">
                    <path
                        id="Path_14"
                        data-name="Path 14"
                        d="M433.71,350.48a25.91,25.91,0,0,0-19.25,31.17s17.9-3.39,20.47-11.53S433.71,350.48,433.71,350.48Z"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_15"
                    data-name="Path 15"
                    d="M458.34,370.86a19.69,19.69,0,1,1-23.7-14.64A19.69,19.69,0,0,1,458.34,370.86Z"
                    fill="#ff735d"
                />
                <path
                    id="Path_16"
                    data-name="Path 16"
                    d="M458.34,370.86a19.69,19.69,0,1,1-23.7-14.64A19.69,19.69,0,0,1,458.34,370.86Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_17"
                    data-name="Path 17"
                    d="M459.07,371.53a19.43,19.43,0,1,1-23.38-14.44A19.43,19.43,0,0,1,459.07,371.53Z"
                    fill="#e3e2e2"
                />
                <g id="Group_2" data-name="Group 2" opacity="0.2">
                    <path
                        id="Path_18"
                        data-name="Path 18"
                        d="M459.07,371.53a19.43,19.43,0,1,1-23.38-14.44A19.43,19.43,0,0,1,459.07,371.53Z"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_19"
                    data-name="Path 19"
                    d="M440.53,374.18l-1.15-4.84h0a10.06,10.06,0,0,1,2.73.06,8.5,8.5,0,0,1,1.38.47v-.16l.33-1.92.08-.44-1.08-.7-.37.28a9.2,9.2,0,0,0-3.74-.18l-.63-2.66-1-.47.15.67-1.13.26.64,2.71c-3.66,1.25-4.93,3.8-4.35,6.24.79,3.33,3.84,3.52,6.66,3.54l1.13,4.79a9.39,9.39,0,0,1-5.22-.68l-.51,2.67a10.82,10.82,0,0,0,6.34.6l.48,2-.93.24,1.08.41,2-.46-.64-2.69c3.67-1.27,5-3.8,4.39-6.25C446.44,374.35,443.34,374.2,440.53,374.18Zm-2.09,0c-1.48-.08-2.64-.36-2.91-1.51s.26-2.09,1.9-2.75ZM439.38,369.38Zm2.83,12-1-4.24c1.54.07,2.72.37,3,1.54s-.31,1.96-2,2.64Z"
                    fill="#565656"
                />
                <g id="Group_3" data-name="Group 3" opacity="0.3">
                    <path
                        id="Path_20"
                        data-name="Path 20"
                        d="M440.53,374.18l-1.15-4.84h0a10.06,10.06,0,0,1,2.73.06,8.5,8.5,0,0,1,1.38.47v-.16l.33-1.92.08-.44-1.08-.7-.37.28a9.2,9.2,0,0,0-3.74-.18l-.63-2.66-1-.47.15.67-1.13.26.64,2.71c-3.66,1.25-4.93,3.8-4.35,6.24.79,3.33,3.84,3.52,6.66,3.54l1.13,4.79a9.39,9.39,0,0,1-5.22-.68l-.51,2.67a10.82,10.82,0,0,0,6.34.6l.48,2-.93.24,1.08.41,2-.46-.64-2.69c3.67-1.27,5-3.8,4.39-6.25C446.44,374.35,443.34,374.2,440.53,374.18Zm-2.09,0c-1.48-.08-2.64-.36-2.91-1.51s.26-2.09,1.9-2.75ZM439.38,369.38Zm2.83,12-1-4.24c1.54.07,2.72.37,3,1.54s-.31,1.96-2,2.64Z"
                    />
                </g>
                <path
                    id="Path_21"
                    data-name="Path 21"
                    d="M441.86,383.47l.64,2.68-2,.47-.6-2.62a10.82,10.82,0,0,1-6.34-.6l.51-2.68a9.48,9.48,0,0,0,5.22.69l-1.13-4.8c-2.81,0-5.87-.2-6.66-3.53-.58-2.45.69-5,4.35-6.24l-.64-2.71,2-.47.63,2.66a10.5,10.5,0,0,1,5.21.32l-.41,2.65a10.34,10.34,0,0,0-4.19-.38l1.15,4.84c2.81,0,5.91.18,6.7,3.51C446.84,379.66,445.54,382.2,441.86,383.47Zm-4.39-9.8-1-4.26c-1.64.66-2.16,1.7-1.91,2.75s1.44,1.44,2.91,1.51Zm5.77,4.49c-.28-1.18-1.46-1.48-3-1.55l1,4.25c1.69-.68,2.24-1.67,2-2.7Z"
                    fill="#717272"
                />
                <path
                    id="Path_22"
                    data-name="Path 22"
                    d="M444.33,395.17l.15-.05.45-.14.73-.22a9,9,0,0,0,1-.34l1.2-.5a5.1,5.1,0,0,0,.67-.32l.71-.38a8.336,8.336,0,0,0,.76-.42l.76-.5c.26-.18.54-.34.8-.55l.79-.65a20.72,20.72,0,0,0,3.17-3.28l.71-1c.11-.18.24-.35.35-.53l.32-.57c.21-.39.44-.77.63-1.17l.55-1.26.14-.31a1.125,1.125,0,0,1,.11-.34l.22-.67.22-.67c.08-.23.11-.47.17-.7.1-.48.22-.95.3-1.43l.18-1.49a19.33,19.33,0,0,0-2.81-11.89l-.82-1.25c-.29-.39-.62-.76-.92-1.14-.15-.18-.29-.38-.46-.55l-.5-.51-.5-.5c-.08-.08-.16-.17-.25-.25l-.26-.22-1.05-.87c-.36-.28-.73-.51-1.09-.77l-.54-.36c-.18-.12-.37-.21-.56-.32l-1.09-.61a21.186,21.186,0,0,0-4.3-1.52l-1-.22c-.33-.07-.65-.08-1-.13l-.91-.11h-1.67a6.059,6.059,0,0,0-.74,0l-1.3.1a6.942,6.942,0,0,0-1,.14l-.75.13-.46.07h-.01l.46-.09.75-.15a8.439,8.439,0,0,1,1-.15l1.31-.12a5.94,5.94,0,0,1,.74,0h.81q.435-.022.87,0l.91.1a6.172,6.172,0,0,1,1,.12l1,.22a21,21,0,0,1,4.34,1.51l1.1.61.57.31.54.37c.36.25.75.49,1.1.77l1.07.88.27.22.25.25.5.51.5.51a4.878,4.878,0,0,1,.47.55c.31.38.63.75.93,1.15s.55.84.83,1.26a19.62,19.62,0,0,1,2.84,12l-.18,1.5c-.09.49-.21,1-.31,1.44a5.683,5.683,0,0,1-.18.71l-.22.68c-.07.23-.15.45-.22.68a1.736,1.736,0,0,1-.12.33l-.14.32c-.18.43-.37.85-.55,1.26s-.43.79-.64,1.18c-.11.19-.22.38-.32.57a6.458,6.458,0,0,1-.37.54l-.72,1a20.488,20.488,0,0,1-3.2,3.29l-.8.64c-.27.21-.55.37-.81.55l-.78.5a8.09,8.09,0,0,1-.76.42l-.71.37a5.211,5.211,0,0,1-.68.32l-1.22.48a6.59,6.59,0,0,1-1,.32l-.73.2-.46.13Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_23"
                    data-name="Path 23"
                    d="M421,392.59s-.06,0-.16-.16a5.373,5.373,0,0,0-.44-.51,10.473,10.473,0,0,1-.66-.83,13.662,13.662,0,0,1-.82-1.14c-.15-.22-.3-.44-.45-.68s-.3-.5-.45-.76c-.32-.53-.61-1.12-.92-1.73a28.1,28.1,0,0,1-1.57-4.2,27.158,27.158,0,0,1-.82-4.4,19.434,19.434,0,0,1-.11-1.95v-1.71a13.3,13.3,0,0,1,.11-1.4,10.418,10.418,0,0,1,.14-1.05l.12-.66v-.23a1.09,1.09,0,0,1,0,.24,2.167,2.167,0,0,1-.08.66,4.973,4.973,0,0,0-.11,1.05c-.02.41-.09.88-.08,1.4v1.69c0,.61.07,1.26.12,1.94a30.568,30.568,0,0,0,.83,4.37,30.073,30.073,0,0,0,1.55,4.17c.31.61.58,1.2.9,1.73.15.26.28.52.43.76l.44.69c.27.44.56.81.79,1.15a9.031,9.031,0,0,0,.64.84l.41.53a.89.89,0,0,1,.19.19Z"
                    fill="#fff"
                />
                <path
                    id="Path_24"
                    data-name="Path 24"
                    d="M433.61,374.65a1.57,1.57,0,0,1-.68-.42,3,3,0,0,1-.72-3.61,1.52,1.52,0,0,1,.47-.65,4.538,4.538,0,0,0-.35.7,3.34,3.34,0,0,0-.18,1.84,3.16,3.16,0,0,0,.87,1.62C433.36,374.48,433.63,374.63,433.61,374.65Z"
                    fill="#fff"
                />
                <path
                    id="Path_25"
                    data-name="Path 25"
                    d="M436.16,366.3a3.361,3.361,0,0,1-.37-1.57,1.94,1.94,0,0,1,.28.76,1.841,1.841,0,0,1,.09.81Z"
                    fill="#fff"
                />
                <path
                    id="Path_26"
                    data-name="Path 26"
                    d="M436.26,355.32a3.822,3.822,0,0,1-.62.12,3.411,3.411,0,0,0-.73.14c-.28.07-.61.11-1,.21s-.73.19-1.14.32-.83.28-1.28.44a21,21,0,0,0-2.82,1.34,21.3,21.3,0,0,0-2.57,1.75,10.109,10.109,0,0,0-1,.89c-.27.3-.6.56-.85.82s-.47.51-.67.72-.35.4-.48.56a3.8,3.8,0,0,1-.42.47,5.713,5.713,0,0,1,.36-.52c.12-.16.27-.36.46-.58s.39-.48.65-.74.53-.56.84-.85.67-.59,1-.91a21.832,21.832,0,0,1,2.6-1.78,20.426,20.426,0,0,1,2.84-1.33c.46-.16.89-.32,1.31-.43s.8-.22,1.15-.3.69-.14,1-.19.53-.08.74-.1Z"
                    fill="#fff"
                />
                <path
                    id="Path_27"
                    data-name="Path 27"
                    d="M448.39,398.87l-.42.23c-.28.14-.69.31-1.2.51a19.12,19.12,0,0,1-4.17,1,18.45,18.45,0,0,1-4.3.06,11.994,11.994,0,0,1-1.29-.19,1.89,1.89,0,0,1-.47-.11,2.461,2.461,0,0,1,.48,0c.3,0,.74.09,1.29.13a21.918,21.918,0,0,0,4.26-.12,21.387,21.387,0,0,0,4.15-1c.52-.18.93-.33,1.22-.45a2.645,2.645,0,0,1,.45-.06Z"
                    fill="#fff"
                />
                <path
                    id="Path_28"
                    data-name="Path 28"
                    d="M464.88,369.73a4.124,4.124,0,0,1-.12-.4c-.08-.27-.17-.67-.34-1.18a25.9,25.9,0,0,0-1.8-4.38,24.916,24.916,0,0,0-1.78-2.92,25.2,25.2,0,0,0-2.59-3.13,26.421,26.421,0,0,0-8.08-5.63,25.168,25.168,0,0,0-5.49-1.73,24.78,24.78,0,0,0-6.21-.46,25.479,25.479,0,0,0-6.56,1.18,24.913,24.913,0,0,0-3.26,1.26,27.717,27.717,0,0,0-3.13,1.76,25.79,25.79,0,0,0-9.61,11.52,24.335,24.335,0,0,0-1.27,3.78,25.192,25.192,0,0,0-.68,4,25.82,25.82,0,0,0,3.75,15.86c.35.59.74,1.14,1.13,1.69a19.392,19.392,0,0,0,1.26,1.58,25.82,25.82,0,0,0,16.58,8.82,27.186,27.186,0,0,0,3.59.16,24.874,24.874,0,0,0,3.48-.32,25.46,25.46,0,0,0,6.39-1.89,25.152,25.152,0,0,0,5.36-3.19,25.7,25.7,0,0,0,4.12-4,26.261,26.261,0,0,0,4.71-8.66,25,25,0,0,0,.91-4,25.574,25.574,0,0,0,.29-3.41,26.665,26.665,0,0,0-.35-4.71c-.08-.54-.18-.94-.23-1.21s-.07-.42-.07-.42.14.56.34,1.62a26.092,26.092,0,0,1,.39,4.73,27.25,27.25,0,0,1-.27,3.41,25.261,25.261,0,0,1-.91,4,26,26,0,0,1-8.84,12.75,25.569,25.569,0,0,1-5.38,3.22,26.351,26.351,0,0,1-6.43,1.91,27.087,27.087,0,0,1-3.51.33,27.513,27.513,0,0,1-3.61-.17,26,26,0,0,1-13.85-6,25.384,25.384,0,0,1-2.85-2.83,17.016,17.016,0,0,1-1.27-1.59c-.41-.59-.79-1.12-1.14-1.71a26.16,26.16,0,0,1-3.19-7.68,25.672,25.672,0,0,1,1.41-16.13A26,26,0,0,1,425.42,354a26.6,26.6,0,0,1,3.16-1.76,24.849,24.849,0,0,1,3.27-1.28,26,26,0,0,1,12.86-.7,24.68,24.68,0,0,1,5.51,1.76,26.37,26.37,0,0,1,8.11,5.68,25.306,25.306,0,0,1,2.59,3.15,24.12,24.12,0,0,1,1.77,2.94,25.617,25.617,0,0,1,1.77,4.39C464.76,369.18,464.88,369.73,464.88,369.73Z"
                    fill="#1a2e35"
                />
                <circle
                    id="Ellipse_4"
                    data-name="Ellipse 4"
                    cx="31.18"
                    cy="31.18"
                    r="31.18"
                    transform="matrix(0.587, -0.809, 0.809, 0.587, 26.896, 375.066)"
                    fill="#717272"
                />
                <g id="Group_4" data-name="Group 4" opacity="0.1">
                    <path
                        id="Path_29"
                        data-name="Path 29"
                        d="M50.32,344.34a31.18,31.18,0,0,0-3.69,43.94S64,374.89,62.33,364.75,50.32,344.34,50.32,344.34Z"
                        fill="#fff"
                    />
                </g>
                <path
                    id="Path_30"
                    data-name="Path 30"
                    d="M87.85,352.8a23.7,23.7,0,1,1-33.4-2.8,23.7,23.7,0,0,1,33.4,2.8Z"
                    fill="#e3e2e2"
                />
                <g id="Group_5" data-name="Group 5" opacity="0.2">
                    <path
                        id="Path_31"
                        data-name="Path 31"
                        d="M87.85,352.8a23.7,23.7,0,1,1-33.4-2.8,23.7,23.7,0,0,1,33.4,2.8Z"
                    />
                </g>
                <path
                    id="Path_32"
                    data-name="Path 32"
                    d="M89,353.12a23.38,23.38,0,1,1-32.95-2.77A23.38,23.38,0,0,1,89,353.12Z"
                    fill="#ff735d"
                />
                <path
                    id="Path_33"
                    data-name="Path 33"
                    d="M89,353.12a23.38,23.38,0,1,1-32.95-2.77A23.38,23.38,0,0,1,89,353.12Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_34"
                    data-name="Path 34"
                    d="M70.54,366.07l-3.86-4.57h0a12,12,0,0,1,3-1.42,10.614,10.614,0,0,1,1.74-.25l-.06-.19-.68-2.24-.16-.52L69,356.7l-.24.5a11.31,11.31,0,0,0-4.12,1.85l-2.12-2.52H61.2l.54.63-1.08.91,2.16,2.56c-3.24,3.32-3.22,6.75-1.26,9.06,2.66,3.15,6,1.69,9.07.18l3.82,4.53a11.37,11.37,0,0,1-6,2.1l.91,3.15a13,13,0,0,0,7.14-2.81l1.6,1.9-.87.76,1.39-.15,1.86-1.56-2.14-2.54c3.25-3.37,3.26-6.79,1.31-9.1C77,363,73.57,364.55,70.54,366.07Zm-2.26,1.09c-1.64.72-3,1-4,0s-.85-2.38.55-4ZM66.68,361.49Zm9.56,11.32-3.38-4c1.68-.76,3.12-1.08,4,0S77.68,371.17,76.24,372.81Z"
                    fill="#ff735d"
                />
                <path
                    id="Path_35"
                    data-name="Path 35"
                    d="M70.54,366.07l-3.86-4.57h0a12,12,0,0,1,3-1.42,10.614,10.614,0,0,1,1.74-.25l-.06-.19-.68-2.24-.16-.52L69,356.7l-.24.5a11.31,11.31,0,0,0-4.12,1.85l-2.12-2.52H61.2l.54.63-1.08.91,2.16,2.56c-3.24,3.32-3.22,6.75-1.26,9.06,2.66,3.15,6,1.69,9.07.18l3.82,4.53a11.37,11.37,0,0,1-6,2.1l.91,3.15a13,13,0,0,0,7.14-2.81l1.6,1.9-.87.76,1.39-.15,1.86-1.56-2.14-2.54c3.25-3.37,3.26-6.79,1.31-9.1C77,363,73.57,364.55,70.54,366.07Zm-2.26,1.09c-1.64.72-3,1-4,0s-.85-2.38.55-4ZM66.68,361.49Zm9.56,11.32-3.38-4c1.68-.76,3.12-1.08,4,0S77.68,371.17,76.24,372.81Z"
                    fill="#565656"
                />
                <path
                    id="Path_36"
                    data-name="Path 36"
                    d="M77,375.31l2.14,2.54-1.86,1.56L75.2,376.9a13,13,0,0,1-7.14,2.81l-.91-3.15a11.33,11.33,0,0,0,6-2.11l-3.83-4.53c-3,1.52-6.41,3-9.07-.17-1.95-2.31-2-5.74,1.27-9.06l-2.16-2.56,1.85-1.57,2.13,2.51a12.739,12.739,0,0,1,5.76-2.5l1,3.07a12.239,12.239,0,0,0-4.71,1.88l3.87,4.57c3-1.51,6.44-3,9.1.11C80.3,368.51,80.28,371.94,77,375.31Zm-10-8.12-3.41-4c-1.39,1.61-1.38,3-.54,4S65.35,367.91,67,367.19Zm8.63,1.67c-.94-1.11-2.37-.79-4.06,0l3.39,4c1.43-1.67,1.48-3.03.66-4Z"
                    fill="#717272"
                />
                <path
                    id="Path_37"
                    data-name="Path 37"
                    d="M86.05,386.53l.13-.14.41-.39.66-.64a8.42,8.42,0,0,0,.87-.9l1-1.18a5.88,5.88,0,0,0,.54-.72l.56-.79c.18-.28.41-.54.58-.86l.54-1c.18-.33.4-.66.56-1s.33-.74.5-1.13a24.251,24.251,0,0,0,1.6-5.22c.06-.49.13-1,.2-1.5,0-.25.07-.51.09-.76v-.79a14.233,14.233,0,0,0,0-1.6c-.06-.54-.07-1.09-.1-1.64v-.42a2.929,2.929,0,0,0-.07-.41l-.13-.84a5,5,0,0,0-.13-.85,6,6,0,0,0-.2-.84c-.15-.56-.27-1.14-.45-1.71l-.62-1.68a25,25,0,0,0-3.83-6.39,25.311,25.311,0,0,0-5.66-4.85l-1.56-.89c-.53-.27-1.08-.49-1.6-.73-.27-.11-.53-.26-.8-.34l-.82-.27-.8-.27-.4-.13-.41-.09-1.6-.37c-.53-.1-1.07-.15-1.59-.23l-.77-.1h-.78l-1.5-.06a24.888,24.888,0,0,0-5.44.71l-1.2.31c-.38.1-.74.26-1.1.38l-1,.38a10.221,10.221,0,0,0-.94.42l-.88.42a7.332,7.332,0,0,0-.79.42l-1.34.81a8.692,8.692,0,0,0-1,.71l-.74.55-.45.33-.17.11.15-.13.44-.35.73-.57a9.761,9.761,0,0,1,1-.73l1.34-.83a5.354,5.354,0,0,1,.79-.42l.87-.43a7.866,7.866,0,0,1,1-.44l1-.39c.36-.12.72-.28,1.11-.39l1.2-.32a25.2,25.2,0,0,1,5.48-.74l1.51.05h.78l.79.1c.52.08,1.06.12,1.6.22l1.62.37.41.09.4.13.81.27.82.28a8.1,8.1,0,0,1,.81.33c.54.25,1.09.47,1.62.74l1.58.89a23.62,23.62,0,0,1,9.59,11.35c.2.58.41,1.14.62,1.71s.3,1.15.45,1.72c.06.28.16.56.2.85l.13.85a6.011,6.011,0,0,0,.13.85c.04.28,0,.28.06.42v.42c0,.56.06,1.11.1,1.66a9.564,9.564,0,0,1-.05,1.61v.79a6.48,6.48,0,0,1-.1.77c-.07.51-.14,1-.21,1.51a25,25,0,0,1-1.65,5.28L92.07,379c-.17.36-.39.69-.57,1l-.56,1c-.17.31-.4.58-.59.86l-.56.79a8.358,8.358,0,0,1-.56.71l-1,1.17a8.279,8.279,0,0,1-.89.89l-.68.62-.42.38Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_38"
                    data-name="Path 38"
                    d="M59.6,396.47l-.27-.09-.74-.31a12.722,12.722,0,0,1-1.17-.52,15.581,15.581,0,0,1-1.5-.78l-.85-.49c-.3-.17-.59-.37-.9-.57-.63-.39-1.26-.87-1.93-1.36a33.782,33.782,0,0,1-4-3.65A33.278,33.278,0,0,1,45,384.42c-.43-.71-.85-1.37-1.18-2-.17-.33-.35-.64-.49-.95s-.28-.61-.41-.9c-.28-.56-.46-1.1-.65-1.56s-.32-.87-.42-1.2-.17-.58-.23-.78a1.29,1.29,0,0,1-.07-.27,1,1,0,0,1,.11.26c.07.2.17.45.28.76s.25.73.45,1.18.39,1,.68,1.55l.42.88c.14.31.33.61.5.93.33.66.76,1.32,1.19,2a35.589,35.589,0,0,0,3.27,4.24,35.107,35.107,0,0,0,3.93,3.63c.67.49,1.28,1,1.9,1.37l.89.58.84.5a14.683,14.683,0,0,0,1.48.8c.48.23.82.42,1.14.56l.73.34a1,1,0,0,1,.24.13Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_39"
                    data-name="Path 39"
                    d="M63.38,370.34a2.08,2.08,0,0,1-1-.08,3.68,3.68,0,0,1-2.74-3.49,1.82,1.82,0,0,1,.16-1s0,.37,0,.95a3.8,3.8,0,0,0,2.62,3.34C63,370.29,63.38,370.3,63.38,370.34Z"
                    fill="#fff"
                />
                <path
                    id="Path_40"
                    data-name="Path 40"
                    d="M61.57,360a3.96,3.96,0,0,1-.72-.67c-.34-.41-.59-.78-.54-.82s.37.26.72.67a2.41,2.41,0,0,1,.54.82Z"
                    fill="#fff"
                />
                <path
                    id="Path_41"
                    data-name="Path 41"
                    d="M55.69,348.14a3.71,3.71,0,0,1-.6.47c-.2.14-.44.32-.71.54s-.58.46-.91.75a7.262,7.262,0,0,0-1,1c-.31.4-.74.75-1.14,1.17A28.869,28.869,0,0,0,49,355a26,26,0,0,0-1.81,3.28c-.23.53-.46,1-.63,1.52s-.34.93-.47,1.35-.23.8-.32,1.13-.17.63-.22.87a4.3,4.3,0,0,1-.19.73,5.679,5.679,0,0,1,.1-.75,8.64,8.64,0,0,1,.18-.88c.08-.34.16-.73.3-1.15s.26-.88.44-1.37.39-1,.61-1.53a22.87,22.87,0,0,1,4.14-6.31c.41-.42.78-.83,1.17-1.17s.74-.67,1.08-1a9.059,9.059,0,0,1,.93-.73,8.41,8.41,0,0,1,.74-.51,5.2,5.2,0,0,1,.64-.34Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M92.42,388.29a2,2,0,0,1-.32.47c-.22.3-.57.72-1,1.21a22.689,22.689,0,0,1-8.49,5.79,13.581,13.581,0,0,1-1.49.5,4.353,4.353,0,0,1-.56.14,1.849,1.849,0,0,1,.53-.22c.35-.12.85-.32,1.45-.57a26.07,26.07,0,0,0,4.52-2.45A25.619,25.619,0,0,0,91,389.85c.46-.47.82-.86,1.06-1.14a2.926,2.926,0,0,1,.36-.42Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_43"
                    data-name="Path 43"
                    d="M94.26,348l-.35-.37c-.23-.24-.54-.63-1-1.08a31.081,31.081,0,0,0-4.31-3.72,31.281,31.281,0,0,0-19.75-5.76A30.53,30.53,0,0,0,62,338.23a30,30,0,0,0-6.92,2.89,31,31,0,0,0-6.4,4.84,30.1,30.1,0,0,0-2.81,3.13,34.583,34.583,0,0,0-2.41,3.59A31.09,31.09,0,0,0,40.15,375a29.059,29.059,0,0,0,1.45,4.65,31.09,31.09,0,0,0,5.11,8.52,31.54,31.54,0,0,0,7.54,6.47c.7.44,1.42.81,2.14,1.2a18.384,18.384,0,0,0,2.22,1,30.351,30.351,0,0,0,4.56,1.49,31.23,31.23,0,0,0,18-1.05,31.9,31.9,0,0,0,3.94-1.77,31.115,31.115,0,0,0,15.99-32.5,29.6,29.6,0,0,0-1.1-4.71,32.214,32.214,0,0,0-1.54-3.82,31.8,31.8,0,0,0-3-4.87c-.37-.53-.7-.91-.9-1.17l-.31-.41s.46.52,1.25,1.55a30.711,30.711,0,0,1,3,4.86,32.048,32.048,0,0,1,1.57,3.82,29.81,29.81,0,0,1,1.19,4.76,31.62,31.62,0,0,1-.3,11.92,30.34,30.34,0,0,1-2.25,6.58,31.5,31.5,0,0,1-13.47,14.2,33,33,0,0,1-4,1.79,31.42,31.42,0,0,1-18.16,1.07,30.823,30.823,0,0,1-4.6-1.49c-.76-.3-1.49-.66-2.23-1a17.711,17.711,0,0,1-2.16-1.21,31.22,31.22,0,0,1-12.75-15.09,31.39,31.39,0,0,1,1.93-27.2A32.518,32.518,0,0,1,45.74,349a30.422,30.422,0,0,1,2.82-3.15,31.09,31.09,0,0,1,20.29-8.87,31.65,31.65,0,0,1,11.8,1.69,29.83,29.83,0,0,1,4.5,2,32.843,32.843,0,0,1,3.5,2.18,31.15,31.15,0,0,1,4.29,3.76C93.83,347.5,94.26,348,94.26,348Z"
                    fill="#565656"
                />
                <rect
                    id="Rectangle_1"
                    data-name="Rectangle 1"
                    width="57.34"
                    height="10.41"
                    transform="translate(423.99 338.54) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_6" data-name="Group 6" opacity="0.5">
                    <path
                        id="Path_44"
                        data-name="Path 44"
                        d="M418.36,338.61a55.7,55.7,0,0,0,0-10.33A58.108,58.108,0,0,0,418.36,338.61Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_7" data-name="Group 7" opacity="0.5">
                    <path
                        id="Path_45"
                        data-name="Path 45"
                        d="M421.5,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_8" data-name="Group 8" opacity="0.5">
                    <path
                        id="Path_46"
                        data-name="Path 46"
                        d="M411.47,338.61a55.7,55.7,0,0,0,0-10.33A58.111,58.111,0,0,0,411.47,338.61Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_9" data-name="Group 9" opacity="0.5">
                    <path
                        id="Path_47"
                        data-name="Path 47"
                        d="M414.61,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_10" data-name="Group 10" opacity="0.5">
                    <path
                        id="Path_48"
                        data-name="Path 48"
                        d="M404.58,338.61a55.7,55.7,0,0,0,0-10.33A58.111,58.111,0,0,0,404.58,338.61Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_11" data-name="Group 11" opacity="0.5">
                    <path
                        id="Path_49"
                        data-name="Path 49"
                        d="M407.72,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_12" data-name="Group 12" opacity="0.5">
                    <path
                        id="Path_50"
                        data-name="Path 50"
                        d="M397.69,338.61a55.7,55.7,0,0,0,0-10.33,58.114,58.114,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_13" data-name="Group 13" opacity="0.5">
                    <path
                        id="Path_51"
                        data-name="Path 51"
                        d="M400.83,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_14" data-name="Group 14" opacity="0.5">
                    <path
                        id="Path_52"
                        data-name="Path 52"
                        d="M390.81,338.61a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_15" data-name="Group 15" opacity="0.5">
                    <path
                        id="Path_53"
                        data-name="Path 53"
                        d="M393.94,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_16" data-name="Group 16" opacity="0.5">
                    <path
                        id="Path_54"
                        data-name="Path 54"
                        d="M383.92,338.61a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_17" data-name="Group 17" opacity="0.5">
                    <path
                        id="Path_55"
                        data-name="Path 55"
                        d="M387.05,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_18" data-name="Group 18" opacity="0.5">
                    <path
                        id="Path_56"
                        data-name="Path 56"
                        d="M377,338.61a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_19" data-name="Group 19" opacity="0.5">
                    <path
                        id="Path_57"
                        data-name="Path 57"
                        d="M380.16,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_20" data-name="Group 20" opacity="0.5">
                    <path
                        id="Path_58"
                        data-name="Path 58"
                        d="M370.14,338.61a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_21" data-name="Group 21" opacity="0.5">
                    <path
                        id="Path_59"
                        data-name="Path 59"
                        d="M373.27,338.61a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_60"
                    data-name="Path 60"
                    d="M366.64,328.13c0,.13,12.9.24,28.8.24s28.81-.11,28.81-.24-12.89-.24-28.81-.24S366.64,328,366.64,328.13Z"
                    fill="#1a2e35"
                />
                <rect
                    id="Rectangle_2"
                    data-name="Rectangle 2"
                    width="57.34"
                    height="10.41"
                    transform="translate(427.73 349.12) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_22" data-name="Group 22" opacity="0.5">
                    <path
                        id="Path_61"
                        data-name="Path 61"
                        d="M422.12,349.19a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,422.12,349.19Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_23" data-name="Group 23" opacity="0.5">
                    <path
                        id="Path_62"
                        data-name="Path 62"
                        d="M425.25,349.19a55.7,55.7,0,0,0,0-10.33,58.1,58.1,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_24" data-name="Group 24" opacity="0.5">
                    <path
                        id="Path_63"
                        data-name="Path 63"
                        d="M415.23,349.19a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_25" data-name="Group 25" opacity="0.5">
                    <path
                        id="Path_64"
                        data-name="Path 64"
                        d="M418.36,349.19a55.7,55.7,0,0,0,0-10.33,58.107,58.107,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_26" data-name="Group 26" opacity="0.5">
                    <path
                        id="Path_65"
                        data-name="Path 65"
                        d="M408.34,349.19a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,408.34,349.19Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_27" data-name="Group 27" opacity="0.5">
                    <path
                        id="Path_66"
                        data-name="Path 66"
                        d="M411.47,349.19a55.7,55.7,0,0,0,0-10.33,58.108,58.108,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_28" data-name="Group 28" opacity="0.5">
                    <path
                        id="Path_67"
                        data-name="Path 67"
                        d="M401.45,349.19a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,401.45,349.19Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_29" data-name="Group 29" opacity="0.5">
                    <path
                        id="Path_68"
                        data-name="Path 68"
                        d="M404.58,349.19a55.7,55.7,0,0,0,0-10.33,58.108,58.108,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_30" data-name="Group 30" opacity="0.5">
                    <path
                        id="Path_69"
                        data-name="Path 69"
                        d="M394.56,349.19a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_31" data-name="Group 31" opacity="0.5">
                    <path
                        id="Path_70"
                        data-name="Path 70"
                        d="M397.69,349.19a55.7,55.7,0,0,0,0-10.33,58.111,58.111,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_32" data-name="Group 32" opacity="0.5">
                    <path
                        id="Path_71"
                        data-name="Path 71"
                        d="M387.67,349.19a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,387.67,349.19Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_33" data-name="Group 33" opacity="0.5">
                    <path
                        id="Path_72"
                        data-name="Path 72"
                        d="M390.81,349.19a58.108,58.108,0,0,0,0-10.33A55.7,55.7,0,0,0,390.81,349.19Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_34" data-name="Group 34" opacity="0.5">
                    <path
                        id="Path_73"
                        data-name="Path 73"
                        d="M380.78,349.19a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_35" data-name="Group 35" opacity="0.5">
                    <path
                        id="Path_74"
                        data-name="Path 74"
                        d="M383.92,349.19a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_36" data-name="Group 36" opacity="0.5">
                    <path
                        id="Path_75"
                        data-name="Path 75"
                        d="M373.89,349.19a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_37" data-name="Group 37" opacity="0.5">
                    <path
                        id="Path_76"
                        data-name="Path 76"
                        d="M377,349.19a58.108,58.108,0,0,0,0-10.33A55.7,55.7,0,0,0,377,349.19Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_77"
                    data-name="Path 77"
                    d="M370.4,338.7c0,.14,12.89.24,28.8.24s28.8-.1,28.8-.24-12.89-.23-28.8-.23S370.4,338.57,370.4,338.7Z"
                    fill="#1a2e35"
                />
                <rect
                    id="Rectangle_3"
                    data-name="Rectangle 3"
                    width="57.34"
                    height="10.41"
                    transform="translate(423.05 359.6) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_38" data-name="Group 38" opacity="0.5">
                    <path
                        id="Path_78"
                        data-name="Path 78"
                        d="M417.43,359.67a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_39" data-name="Group 39" opacity="0.5">
                    <path
                        id="Path_79"
                        data-name="Path 79"
                        d="M420.57,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,420.57,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_40" data-name="Group 40" opacity="0.5">
                    <path
                        id="Path_80"
                        data-name="Path 80"
                        d="M410.54,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,410.54,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_41" data-name="Group 41" opacity="0.5">
                    <path
                        id="Path_81"
                        data-name="Path 81"
                        d="M413.68,359.67a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_42" data-name="Group 42" opacity="0.5">
                    <path
                        id="Path_82"
                        data-name="Path 82"
                        d="M403.65,359.67a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_43" data-name="Group 43" opacity="0.5">
                    <path
                        id="Path_83"
                        data-name="Path 83"
                        d="M406.79,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,406.79,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_44" data-name="Group 44" opacity="0.5">
                    <path
                        id="Path_84"
                        data-name="Path 84"
                        d="M396.76,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,396.76,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_45" data-name="Group 45" opacity="0.5">
                    <path
                        id="Path_85"
                        data-name="Path 85"
                        d="M399.9,359.67a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_46" data-name="Group 46" opacity="0.5">
                    <path
                        id="Path_86"
                        data-name="Path 86"
                        d="M389.87,359.67a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_47" data-name="Group 47" opacity="0.5">
                    <path
                        id="Path_87"
                        data-name="Path 87"
                        d="M393,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,393,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_48" data-name="Group 48" opacity="0.5">
                    <path
                        id="Path_88"
                        data-name="Path 88"
                        d="M383,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,383,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_49" data-name="Group 49" opacity="0.5">
                    <path
                        id="Path_89"
                        data-name="Path 89"
                        d="M386.12,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,386.12,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_50" data-name="Group 50" opacity="0.5">
                    <path
                        id="Path_90"
                        data-name="Path 90"
                        d="M376.09,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,376.09,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_51" data-name="Group 51" opacity="0.5">
                    <path
                        id="Path_91"
                        data-name="Path 91"
                        d="M379.23,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,379.23,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_52" data-name="Group 52" opacity="0.5">
                    <path
                        id="Path_92"
                        data-name="Path 92"
                        d="M369.2,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,369.2,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_53" data-name="Group 53" opacity="0.5">
                    <path
                        id="Path_93"
                        data-name="Path 93"
                        d="M372.34,359.67a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,372.34,359.67Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_94"
                    data-name="Path 94"
                    d="M365.71,349.19c0,.13,12.93.24,28.87.24s28.88-.11,28.88-.24-12.93-.24-28.88-.24S365.71,349.06,365.71,349.19Z"
                    fill="#1a2e35"
                />
                <rect
                    id="Rectangle_4"
                    data-name="Rectangle 4"
                    width="57.34"
                    height="10.41"
                    transform="translate(427.55 369.93) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_54" data-name="Group 54" opacity="0.5">
                    <path
                        id="Path_95"
                        data-name="Path 95"
                        d="M421.93,370a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_55" data-name="Group 55" opacity="0.5">
                    <path
                        id="Path_96"
                        data-name="Path 96"
                        d="M425.06,370a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,425.06,370Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_56" data-name="Group 56" opacity="0.5">
                    <path
                        id="Path_97"
                        data-name="Path 97"
                        d="M415,370a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,415,370Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_57" data-name="Group 57" opacity="0.5">
                    <path
                        id="Path_98"
                        data-name="Path 98"
                        d="M418.17,370a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,418.17,370Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_58" data-name="Group 58" opacity="0.5">
                    <path
                        id="Path_99"
                        data-name="Path 99"
                        d="M408.15,370a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,408.15,370Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_59" data-name="Group 59" opacity="0.5">
                    <path
                        id="Path_100"
                        data-name="Path 100"
                        d="M411.28,370a55.7,55.7,0,0,0,0-10.33,58.108,58.108,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_60" data-name="Group 60" opacity="0.5">
                    <path
                        id="Path_101"
                        data-name="Path 101"
                        d="M401.26,370a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,401.26,370Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_61" data-name="Group 61" opacity="0.5">
                    <path
                        id="Path_102"
                        data-name="Path 102"
                        d="M404.39,370a55.7,55.7,0,0,0,0-10.33,58.111,58.111,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_62" data-name="Group 62" opacity="0.5">
                    <path
                        id="Path_103"
                        data-name="Path 103"
                        d="M394.37,370a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,394.37,370Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_63" data-name="Group 63" opacity="0.5">
                    <path
                        id="Path_104"
                        data-name="Path 104"
                        d="M397.5,370a55.7,55.7,0,0,0,0-10.33,58.111,58.111,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_64" data-name="Group 64" opacity="0.5">
                    <path
                        id="Path_105"
                        data-name="Path 105"
                        d="M387.48,370a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_65" data-name="Group 65" opacity="0.5">
                    <path
                        id="Path_106"
                        data-name="Path 106"
                        d="M390.61,370a55.7,55.7,0,0,0,0-10.33,58.111,58.111,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_66" data-name="Group 66" opacity="0.5">
                    <path
                        id="Path_107"
                        data-name="Path 107"
                        d="M380.59,370a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_67" data-name="Group 67" opacity="0.5">
                    <path
                        id="Path_108"
                        data-name="Path 108"
                        d="M383.72,370a55.7,55.7,0,0,0,0-10.33,58.114,58.114,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_68" data-name="Group 68" opacity="0.5">
                    <path
                        id="Path_109"
                        data-name="Path 109"
                        d="M373.7,370a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_69" data-name="Group 69" opacity="0.5">
                    <path
                        id="Path_110"
                        data-name="Path 110"
                        d="M376.83,370a55.7,55.7,0,0,0,0-10.33,58.108,58.108,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_111"
                    data-name="Path 111"
                    d="M370.2,359.52c0,.13,12.9.24,28.81.24s28.8-.11,28.8-.24-12.89-.24-28.8-.24S370.2,359.39,370.2,359.52Z"
                    fill="#1a2e35"
                />
                <rect
                    id="Rectangle_5"
                    data-name="Rectangle 5"
                    width="57.34"
                    height="10.41"
                    transform="translate(421.8 380.49) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_70" data-name="Group 70" opacity="0.5">
                    <path
                        id="Path_112"
                        data-name="Path 112"
                        d="M416.18,380.57a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,416.18,380.57Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_71" data-name="Group 71" opacity="0.5">
                    <path
                        id="Path_113"
                        data-name="Path 113"
                        d="M419.32,380.57a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,419.32,380.57Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_72" data-name="Group 72" opacity="0.5">
                    <path
                        id="Path_114"
                        data-name="Path 114"
                        d="M409.29,380.57a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,409.29,380.57Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_73" data-name="Group 73" opacity="0.5">
                    <path
                        id="Path_115"
                        data-name="Path 115"
                        d="M412.43,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_74" data-name="Group 74" opacity="0.5">
                    <path
                        id="Path_116"
                        data-name="Path 116"
                        d="M402.4,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_75" data-name="Group 75" opacity="0.5">
                    <path
                        id="Path_117"
                        data-name="Path 117"
                        d="M405.54,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_76" data-name="Group 76" opacity="0.5">
                    <path
                        id="Path_118"
                        data-name="Path 118"
                        d="M395.51,380.57a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,395.51,380.57Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_77" data-name="Group 77" opacity="0.5">
                    <path
                        id="Path_119"
                        data-name="Path 119"
                        d="M398.65,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_78" data-name="Group 78" opacity="0.5">
                    <path
                        id="Path_120"
                        data-name="Path 120"
                        d="M388.62,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_79" data-name="Group 79" opacity="0.5">
                    <path
                        id="Path_121"
                        data-name="Path 121"
                        d="M391.76,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_80" data-name="Group 80" opacity="0.5">
                    <path
                        id="Path_122"
                        data-name="Path 122"
                        d="M381.73,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_81" data-name="Group 81" opacity="0.5">
                    <path
                        id="Path_123"
                        data-name="Path 123"
                        d="M384.87,380.57a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,384.87,380.57Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_82" data-name="Group 82" opacity="0.5">
                    <path
                        id="Path_124"
                        data-name="Path 124"
                        d="M374.84,380.57a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,374.84,380.57Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_83" data-name="Group 83" opacity="0.5">
                    <path
                        id="Path_125"
                        data-name="Path 125"
                        d="M378,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_84" data-name="Group 84" opacity="0.5">
                    <path
                        id="Path_126"
                        data-name="Path 126"
                        d="M368,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_85" data-name="Group 85" opacity="0.5">
                    <path
                        id="Path_127"
                        data-name="Path 127"
                        d="M371.09,380.57a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_128"
                    data-name="Path 128"
                    d="M364.46,370.08c0,.13,12.9.24,28.8.24s28.81-.11,28.81-.24-12.9-.24-28.81-.24S364.46,370,364.46,370.08Z"
                    fill="#1a2e35"
                />
                <rect
                    id="Rectangle_6"
                    data-name="Rectangle 6"
                    width="57.34"
                    height="10.41"
                    transform="translate(425.4 391.03) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_86" data-name="Group 86" opacity="0.5">
                    <path
                        id="Path_129"
                        data-name="Path 129"
                        d="M419.78,391.1a58.111,58.111,0,0,0,0-10.33A55.7,55.7,0,0,0,419.78,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_87" data-name="Group 87" opacity="0.5">
                    <path
                        id="Path_130"
                        data-name="Path 130"
                        d="M422.91,391.1a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_88" data-name="Group 88" opacity="0.5">
                    <path
                        id="Path_131"
                        data-name="Path 131"
                        d="M412.89,391.1a58.111,58.111,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_89" data-name="Group 89" opacity="0.5">
                    <path
                        id="Path_132"
                        data-name="Path 132"
                        d="M416,391.1a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_90" data-name="Group 90" opacity="0.5">
                    <path
                        id="Path_133"
                        data-name="Path 133"
                        d="M406,391.1a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_91" data-name="Group 91" opacity="0.5">
                    <path
                        id="Path_134"
                        data-name="Path 134"
                        d="M409.13,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,409.13,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_92" data-name="Group 92" opacity="0.5">
                    <path
                        id="Path_135"
                        data-name="Path 135"
                        d="M399.11,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,399.11,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_93" data-name="Group 93" opacity="0.5">
                    <path
                        id="Path_136"
                        data-name="Path 136"
                        d="M402.24,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,402.24,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_94" data-name="Group 94" opacity="0.5">
                    <path
                        id="Path_137"
                        data-name="Path 137"
                        d="M392.22,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,392.22,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_95" data-name="Group 95" opacity="0.5">
                    <path
                        id="Path_138"
                        data-name="Path 138"
                        d="M395.35,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,395.35,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_96" data-name="Group 96" opacity="0.5">
                    <path
                        id="Path_139"
                        data-name="Path 139"
                        d="M385.33,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,385.33,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_97" data-name="Group 97" opacity="0.5">
                    <path
                        id="Path_140"
                        data-name="Path 140"
                        d="M388.46,391.1a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_98" data-name="Group 98" opacity="0.5">
                    <path
                        id="Path_141"
                        data-name="Path 141"
                        d="M378.44,391.1a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_99" data-name="Group 99" opacity="0.5">
                    <path
                        id="Path_142"
                        data-name="Path 142"
                        d="M381.57,391.1a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_100" data-name="Group 100" opacity="0.5">
                    <path
                        id="Path_143"
                        data-name="Path 143"
                        d="M371.55,391.1a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_101" data-name="Group 101" opacity="0.5">
                    <path
                        id="Path_144"
                        data-name="Path 144"
                        d="M374.68,391.1a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,374.68,391.1Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_145"
                    data-name="Path 145"
                    d="M368.05,380.61c0,.14,12.93.24,28.87.24s28.88-.1,28.88-.24-12.93-.24-28.88-.24S368.05,380.48,368.05,380.61Z"
                    fill="#1a2e35"
                />
                <rect
                    id="Rectangle_7"
                    data-name="Rectangle 7"
                    width="57.34"
                    height="10.41"
                    transform="translate(429.74 401.44) rotate(180)"
                    fill="#717272"
                />
                <g id="Group_102" data-name="Group 102" opacity="0.5">
                    <path
                        id="Path_146"
                        data-name="Path 146"
                        d="M424.13,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_103" data-name="Group 103" opacity="0.5">
                    <path
                        id="Path_147"
                        data-name="Path 147"
                        d="M427.26,401.51a55.7,55.7,0,0,0,0-10.33A58.111,58.111,0,0,0,427.26,401.51Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_104" data-name="Group 104" opacity="0.5">
                    <path
                        id="Path_148"
                        data-name="Path 148"
                        d="M417.24,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_105" data-name="Group 105" opacity="0.5">
                    <path
                        id="Path_149"
                        data-name="Path 149"
                        d="M420.37,401.51a55.7,55.7,0,0,0,0-10.33A58.111,58.111,0,0,0,420.37,401.51Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_106" data-name="Group 106" opacity="0.5">
                    <path
                        id="Path_150"
                        data-name="Path 150"
                        d="M410.35,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_107" data-name="Group 107" opacity="0.5">
                    <path
                        id="Path_151"
                        data-name="Path 151"
                        d="M413.48,401.51a55.7,55.7,0,0,0,0-10.33,58.111,58.111,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_108" data-name="Group 108" opacity="0.5">
                    <path
                        id="Path_152"
                        data-name="Path 152"
                        d="M403.46,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_109" data-name="Group 109" opacity="0.5">
                    <path
                        id="Path_153"
                        data-name="Path 153"
                        d="M406.59,401.51a55.7,55.7,0,0,0,0-10.33,58.111,58.111,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_110" data-name="Group 110" opacity="0.5">
                    <path
                        id="Path_154"
                        data-name="Path 154"
                        d="M396.57,401.51a55.7,55.7,0,0,0,0-10.33A55.7,55.7,0,0,0,396.57,401.51Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_111" data-name="Group 111" opacity="0.5">
                    <path
                        id="Path_155"
                        data-name="Path 155"
                        d="M399.71,401.51a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_112" data-name="Group 112" opacity="0.5">
                    <path
                        id="Path_156"
                        data-name="Path 156"
                        d="M389.68,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_113" data-name="Group 113" opacity="0.5">
                    <path
                        id="Path_157"
                        data-name="Path 157"
                        d="M392.82,401.51a58.108,58.108,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_114" data-name="Group 114" opacity="0.5">
                    <path
                        id="Path_158"
                        data-name="Path 158"
                        d="M382.79,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_115" data-name="Group 115" opacity="0.5">
                    <path
                        id="Path_159"
                        data-name="Path 159"
                        d="M385.93,401.51a58.108,58.108,0,0,0,0-10.33A55.7,55.7,0,0,0,385.93,401.51Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_116" data-name="Group 116" opacity="0.5">
                    <path
                        id="Path_160"
                        data-name="Path 160"
                        d="M375.9,401.51a55.7,55.7,0,0,0,0-10.33,55.7,55.7,0,0,0,0,10.33Z"
                        fill="#1a2e35"
                    />
                </g>
                <g id="Group_117" data-name="Group 117" opacity="0.5">
                    <path
                        id="Path_161"
                        data-name="Path 161"
                        d="M379,401.51a58.108,58.108,0,0,0,0-10.33A55.7,55.7,0,0,0,379,401.51Z"
                        fill="#1a2e35"
                    />
                </g>
                <path
                    id="Path_162"
                    data-name="Path 162"
                    d="M372.41,391c0,.13,12.89.24,28.8.24s28.8-.11,28.8-.24-12.89-.24-28.8-.24S372.41,390.89,372.41,391Z"
                    fill="#1a2e35"
                />
                <g id="Group_118" data-name="Group 118" opacity="0.3">
                    <path
                        id="Path_163"
                        data-name="Path 163"
                        d="M423.05,349.19a87.911,87.911,0,0,1-26.49,1.93c-8.8-.59-17.68-1.88-26.5-1.78Z"
                    />
                </g>
                <g id="Group_119" data-name="Group 119" opacity="0.3">
                    <path
                        id="Path_164"
                        data-name="Path 164"
                        d="M422.53,338.82a87.549,87.549,0,0,1-26.48,1.93c-8.8-.58-17.69-1.88-26.51-1.77Z"
                    />
                </g>
                <g id="Group_120" data-name="Group 120" opacity="0.3">
                    <path
                        id="Path_165"
                        data-name="Path 165"
                        d="M419.76,359.62a87.61,87.61,0,0,1-26.49,1.93c-8.8-.58-17.69-1.88-26.5-1.77Z"
                    />
                </g>
                <g id="Group_121" data-name="Group 121" opacity="0.3">
                    <path
                        id="Path_166"
                        data-name="Path 166"
                        d="M422,370a87.609,87.609,0,0,1-26.49,1.92c-8.8-.58-17.69-1.87-26.5-1.77Z"
                    />
                </g>
                <g id="Group_122" data-name="Group 122" opacity="0.3">
                    <path
                        id="Path_167"
                        data-name="Path 167"
                        d="M421.32,380.37a87.549,87.549,0,0,1-26.48,1.93c-8.8-.59-17.69-1.88-26.51-1.77Z"
                    />
                </g>
                <g id="Group_123" data-name="Group 123" opacity="0.3">
                    <path
                        id="Path_168"
                        data-name="Path 168"
                        d="M424.13,390.92a87.289,87.289,0,0,1-26.49,1.93c-8.8-.58-17.69-1.88-26.51-1.77Z"
                    />
                </g>
                <path
                    id="Path_169"
                    data-name="Path 169"
                    d="M422.93,335.25a17,17,0,0,0,0-5.7A17,17,0,0,0,422.93,335.25Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_170"
                    data-name="Path 170"
                    d="M426.55,346.38a19.631,19.631,0,0,0,0-6.12A19.631,19.631,0,0,0,426.55,346.38Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_171"
                    data-name="Path 171"
                    d="M421.4,357.08a15.42,15.42,0,0,0,0-5.42,15.421,15.421,0,0,0,0,5.42Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_172"
                    data-name="Path 172"
                    d="M426.69,367a12.47,12.47,0,0,0,0-4.87,12.47,12.47,0,0,0,0,4.87Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_173"
                    data-name="Path 173"
                    d="M405.69,339.56a94.116,94.116,0,0,0,9.45.24,94.25,94.25,0,0,0,9.46-.24,94.251,94.251,0,0,0-9.46-.24,94.116,94.116,0,0,0-9.45.24Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_174"
                    data-name="Path 174"
                    d="M399.57,329.55c0,.13,4.26.24,9.52.24s9.53-.11,9.53-.24-4.26-.24-9.53-.24S399.57,329.42,399.57,329.55Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_175"
                    data-name="Path 175"
                    d="M390.39,329.69a21.41,21.41,0,0,0,6.26,0,20.529,20.529,0,0,0-6.26,0Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_176"
                    data-name="Path 176"
                    d="M421,380.12a44.09,44.09,0,0,0,0-8,46.674,46.674,0,0,0,0,8Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_177"
                    data-name="Path 177"
                    d="M377.41,368.85c0,.1,10.43.18,23.29.18s23.3-.03,23.3-.18-10.43-.17-23.29-.17S377.41,368.75,377.41,368.85Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_178"
                    data-name="Path 178"
                    d="M386.73,389.89c0,.09,8.24.17,18.4.17s18.41-.08,18.41-.17-8.24-.18-18.41-.18S386.73,389.79,386.73,389.89Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_179"
                    data-name="Path 179"
                    d="M429.1,399.35a15,15,0,0,0,0-4.51,14.222,14.222,0,0,0,0,4.51Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_180"
                    data-name="Path 180"
                    d="M388.53,400.25c0,.1,8.54.18,19.08.18s19.08-.08,19.08-.18-8.54-.17-19.08-.17S388.53,400.16,388.53,400.25Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_181"
                    data-name="Path 181"
                    d="M429.89,401.36a.757.757,0,0,0,0-.19v-2.66c0-1.86,0-4.47.06-7.66v-.14h-4.23l.15.15V380.29h-4l.17.17V369.9l-.16.16h5.67v-.14c0-3.16,0-5.76-.06-7.6v0c0,1.84,0,4.44-.06,7.6l.14-.13h-5.7v10.9h4l-.18-.18v10.56h.16l4.09-.06-.14-.14c0,3.19.05,5.8.06,7.66v2.66a.756.756,0,0,0,.03.17Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_182"
                    data-name="Path 182"
                    d="M112.73,212.9H347.38a23,23,0,0,1,23,23V368.34a30.86,30.86,0,0,1-30.86,30.86h-220A30.86,30.86,0,0,1,88.7,368.34V236.94a24,24,0,0,1,24.03-24.04Z"
                    fill="#565656"
                />
                <path
                    id="Path_183"
                    data-name="Path 183"
                    d="M76.91,385.42H382.13v2.71a13.59,13.59,0,0,1-13.59,13.59h-278a13.59,13.59,0,0,1-13.59-13.59v-2.71Z"
                    fill="#565656"
                />
                <rect
                    id="Rectangle_8"
                    data-name="Rectangle 8"
                    width="265.81"
                    height="157.32"
                    rx="15.37"
                    transform="translate(96.26 220.31)"
                    fill="#fff"
                />
                <path
                    id="Path_184"
                    data-name="Path 184"
                    d="M201.78,385.42l3.79,6.03h53.3l3.51-6.03Z"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_9"
                    data-name="Rectangle 9"
                    width="281.72"
                    height="0.9"
                    transform="translate(88.74 385.37)"
                    fill="#717272"
                />
                <rect
                    id="Rectangle_10"
                    data-name="Rectangle 10"
                    width="24.06"
                    height="49.39"
                    transform="translate(118.74 328.24)"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_11"
                    data-name="Rectangle 11"
                    width="24.06"
                    height="74.18"
                    transform="translate(156.65 303.45)"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_12"
                    data-name="Rectangle 12"
                    width="24.06"
                    height="74.18"
                    transform="translate(195.89 303.45)"
                    fill="#e3e2e2"
                    opacity="0.5"
                />
                <rect
                    id="Rectangle_13"
                    data-name="Rectangle 13"
                    width="24.06"
                    height="110.25"
                    transform="translate(276.36 267.38)"
                    fill="#e3e2e2"
                    opacity="0.5"
                />
                <rect
                    id="Rectangle_14"
                    data-name="Rectangle 14"
                    width="24.06"
                    height="134.01"
                    transform="translate(313.17 243.62)"
                    fill="#e3e2e2"
                    opacity="0.5"
                />
                <path
                    id="Path_185"
                    data-name="Path 185"
                    d="M168.79,323.5l28.07-40.42,52.76-41.14,28.45,75.43S245.82,338,237.43,340.09s-14.51,1.86-23.79,15.44Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_186"
                    data-name="Path 186"
                    d="M289.07,229.59c.79,0,10.45,6.93,5,12.6-5.79,6-26.41,23.65-26.41,23.65s-10.46-1-8.2-7S289.07,229.59,289.07,229.59Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_187"
                    data-name="Path 187"
                    d="M297.31,332.74a60.544,60.544,0,0,1-37.94-110.08l53.32-37.18L329.1,209l-53.33,37.18a31.864,31.864,0,0,0,36.14,52.49l52.94-40.24L382.2,281.2l-53.46,40.64-.26.18a60.06,60.06,0,0,1-31.17,10.72Z"
                    fill="#565656"
                />
                <path
                    id="Path_188"
                    data-name="Path 188"
                    d="M355.14,290.88l5.31,6.85L382.2,281.2l-4.63-6.06Z"
                    fill="#e1e1e1"
                />
                <path
                    id="Path_189"
                    data-name="Path 189"
                    d="M302.26,218.52l4.41,6.07,22.43-15.64-4.41-6.17Z"
                    fill="#e1e1e1"
                />
                <g id="Group_124" data-name="Group 124" opacity="0.3">
                    <path
                        id="Path_190"
                        data-name="Path 190"
                        d="M297.36,332.81a60.544,60.544,0,0,1-37.94-110.08l53.32-37.18L329.15,209l-53.33,37.18A31.884,31.884,0,0,0,312,298.69l52.94-40.24,17.35,22.82-53.46,40.64-.26.18a60.06,60.06,0,0,1-31.21,10.72Z"
                    />
                </g>
                <path
                    id="Path_191"
                    data-name="Path 191"
                    d="M292.85,326.63a60.544,60.544,0,0,1-37.94-110.08l53.33-37.18,16.39,23.51L271.32,240a31.864,31.864,0,0,0,36.14,52.49l52.93-40.24,17.37,23.09-53.48,40.37-.26.18a60,60,0,0,1-31.17,10.74Z"
                    fill="#717272"
                />
                <path
                    id="Path_192"
                    data-name="Path 192"
                    d="M267.62,276.7l1.72-1.32c3.88-4.25,3.19-8.34-.79-11a5.26,5.26,0,0,0-2.48-.94c-4.33-.32-15.33,1.37-19.94,3.46s-6.8,7.41-3.73,11.15,7,3,13.42,2.27A36.51,36.51,0,0,0,267.62,276.7Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_193"
                    data-name="Path 193"
                    d="M253.05,284.67s-6.42,4.61-3.8,9.79,5.73,4.78,11.36,3.86S274.9,289,274.9,289s3.51-5.26.67-9c-3.83-5-7-2.93-10.28-1.76S253.05,284.67,253.05,284.67Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_194"
                    data-name="Path 194"
                    d="M266.81,297.18s-4.61,8.39,1.39,11.29c5.33,2.58,10.06-2.49,12.93-6.55s5.4-7.5,1.33-10.62c-3.85-2.95-5.93-3.26-8.43-1.48A39.379,39.379,0,0,0,266.81,297.18Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_195"
                    data-name="Path 195"
                    d="M184.77,301.22s11.72-32,15.54-40,27-26.58,27-26.58l24.26-11.08s9,10.64-2,18.4a204.81,204.81,0,0,1-21,13l-2.28,15.34s7.11,36.6-21.79,58.7Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_196"
                    data-name="Path 196"
                    d="M229.34,254.86a.465.465,0,0,1-.05.17l-.17.51c-.17.43-.39,1.09-.66,1.93a42.318,42.318,0,0,0-1.53,7.34,78.868,78.868,0,0,0-.44,11.12c.08,4.19.37,8.8.35,13.66a53.821,53.821,0,0,1-1.55,13.58,31.08,31.08,0,0,1-4.68,10.12,22.17,22.17,0,0,1-5.33,5.3l-1,.65c-.29.18-.55.3-.76.41l-.47.25-.17.07.15-.1.46-.28c.19-.12.45-.25.74-.44l1-.67a22.52,22.52,0,0,0,5.2-5.33A31.4,31.4,0,0,0,225,303.09a54.511,54.511,0,0,0,1.51-13.5c0-4.84-.26-9.45-.32-13.66a77,77,0,0,1,.51-11.15,40.333,40.333,0,0,1,1.65-7.35c.29-.84.53-1.49.72-1.92l.21-.49Q229.306,254.939,229.34,254.86Z"
                    fill="#717272"
                />
                <path
                    id="Path_197"
                    data-name="Path 197"
                    d="M285.32,195.4l16.94,23.12,22.43-15.74-16.32-23.66Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_198"
                    data-name="Path 198"
                    d="M337.84,269.3l18.05,22.5,21.86-16.44L360.5,252.21Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_199"
                    data-name="Path 199"
                    d="M263.38,263.45a4.719,4.719,0,0,1,.81-.07h.97l.61.05.68.13a7.28,7.28,0,0,1,5.55,5h0a7.25,7.25,0,0,1-.56,3.36,10.2,10.2,0,0,1-3.49,4.29,17,17,0,0,1-4,2.08c-1.21.45-2.21.73-2.9.93a8,8,0,0,1-1.08.25,6.4,6.4,0,0,1,1-.38c.68-.24,1.66-.55,2.85-1a18.1,18.1,0,0,0,3.91-2.11,10.07,10.07,0,0,0,3.36-4.16,7,7,0,0,0,.54-3.2h0a7.09,7.09,0,0,0-5.27-4.91l-.66-.15-.59-.07-.52-.06h-.44A4,4,0,0,1,263.38,263.45Z"
                    fill="#ff9c6a"
                />
                <path
                    id="Path_200"
                    data-name="Path 200"
                    d="M276,287.19a2.3,2.3,0,0,1-.32.52c-.22.33-.57.79-1,1.35a33.211,33.211,0,0,1-3.8,4,23.359,23.359,0,0,1-4.52,3.21,11.468,11.468,0,0,1-1.53.71,2.379,2.379,0,0,1-.59.19c0-.06.78-.4,2-1.11a28.651,28.651,0,0,0,4.41-3.26,42.424,42.424,0,0,0,3.84-3.94,20.907,20.907,0,0,1,1.51-1.67Z"
                    fill="#ff9c6a"
                />
                <path
                    id="Path_201"
                    data-name="Path 201"
                    d="M108.56,377.63l59.49-60.81,53.37,43.22-13.74,17.68Z"
                    fill="#717272"
                />
                <path
                    id="Path_202"
                    data-name="Path 202"
                    d="M138.77,234.31a20.67,20.67,0,0,1,5.07-2.2l1-5,8.48-.15,1.22,5a21,21,0,0,1,5.15,2l4.29-2.81,6.1,5.9-2.66,4.38a20.7,20.7,0,0,1,2.21,5.07l5,1.05.14,8.48-5,1.22a20.359,20.359,0,0,1-2,5.14l2.81,4.29-5.89,6.1-4.38-2.65a20.9,20.9,0,0,1-5.08,2.2l-1,5-8.48.15-1.22-5a20.61,20.61,0,0,1-5.15-2l-4.29,2.81-6.1-5.89,2.66-4.38a20.67,20.67,0,0,1-2.2-5.07l-5-1.05-.15-8.48,5-1.22a20.36,20.36,0,0,1,2-5.14l-2.81-4.29,5.89-6.1,4.39,2.65Zm4.52,11.3a9.1,9.1,0,1,0,12.86-.22,9.1,9.1,0,0,0-12.86.22Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_203"
                    data-name="Path 203"
                    d="M122.71,284.12a15.229,15.229,0,0,1,3.69-1.6l.76-3.65,6.18-.11.88,3.62a14.869,14.869,0,0,1,3.75,1.48l3.12-2.05,4.44,4.29-1.93,3.19a15.23,15.23,0,0,1,1.6,3.69l3.66.76.1,6.18-3.62.88a15.23,15.23,0,0,1-1.47,3.75l2,3.12-4.29,4.44-3.19-1.93a15.059,15.059,0,0,1-3.69,1.6l-.76,3.66-6.17.1-.89-3.62a15.229,15.229,0,0,1-3.75-1.47l-3.12,2-4.44-4.29,1.93-3.19a15.23,15.23,0,0,1-1.6-3.69l-3.65-.76-.11-6.17,3.62-.89a14.871,14.871,0,0,1,1.48-3.75l-2-3.12,4.29-4.44,3.19,1.93Zm3.29,8.23a6.61,6.61,0,1,0,4.65-2.033A6.62,6.62,0,0,0,126,292.35Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_204"
                    data-name="Path 204"
                    d="M185.58,233.15a10.319,10.319,0,0,1,2.49-1.08l.52-2.47,4.16-.07.6,2.45a9.789,9.789,0,0,1,2.53,1l2.11-1.38,3,2.89-1.31,2.16a9.789,9.789,0,0,1,1.08,2.49l2.47.51.07,4.17-2.44.6a10.5,10.5,0,0,1-1,2.53l1.38,2.1-2.89,3-2.16-1.3a10.379,10.379,0,0,1-2.49,1.08l-.51,2.46-4.17.08-.6-2.45a10.47,10.47,0,0,1-2.53-1l-2.1,1.38-3-2.9,1.31-2.15a10.36,10.36,0,0,1-1.09-2.49l-2.46-.52-.08-4.16,2.45-.6a10.56,10.56,0,0,1,1-2.53l-1.38-2.11,2.9-3,2.15,1.3Zm2.22,5.55a4.47,4.47,0,1,0,6.32-.11A4.47,4.47,0,0,0,187.8,238.7Z"
                    fill="#e3e2e2"
                />
                <rect
                    id="Rectangle_15"
                    data-name="Rectangle 15"
                    width="24.06"
                    height="33.61"
                    transform="translate(235.44 344.02)"
                    fill="#e3e2e2"
                    opacity="0.5"
                />
                <path
                    id="Path_205"
                    data-name="Path 205"
                    d="M130.11,280.7a8.46,8.46,0,0,0-9.11-.23,10,10,0,0,0-16-5,10.16,10.16,0,0,0-17.17,6.38c-4,.21-8.14,2.86-9,7.36h54.65A8.47,8.47,0,0,0,130.11,280.7Z"
                    fill="#fff"
                />
                <path
                    id="Path_206"
                    data-name="Path 206"
                    d="M130.11,280.7l.52.37a8.39,8.39,0,0,1,1.3,1.34,8.861,8.861,0,0,1,1.39,2.69,8.4,8.4,0,0,1,.22,4.11v.07h-.08l-54.65.08h-.22v-.2l.06-.27a8.79,8.79,0,0,1,3.39-5.19,10.58,10.58,0,0,1,5.69-2l-.16.16a10.33,10.33,0,0,1,17.44-6.48h-.19a10.25,10.25,0,0,1,5.4-2.24,9.91,9.91,0,0,1,5.24.82,10.37,10.37,0,0,1,5.58,6.52l-.13-.05a8.28,8.28,0,0,1,3.93-1.19,8.451,8.451,0,0,1,3,.38,8,8,0,0,1,1.71.76c.35.23.52.36.52.36l-.14-.07-.41-.25a9,9,0,0,0-1.71-.71,8.6,8.6,0,0,0-3-.33,8.18,8.18,0,0,0-3.85,1.2l-.1.07v-.12a10.2,10.2,0,0,0-5.51-6.35,9.75,9.75,0,0,0-5.11-.77A10,10,0,0,0,105,275.6l-.1.09-.1-.09A10,10,0,0,0,88,281.85V282h-.15a10.23,10.23,0,0,0-5.5,2A8.44,8.44,0,0,0,79,289l-.06.25L78.8,289l54.65.09-.09.07a8.19,8.19,0,0,0-.18-4,9,9,0,0,0-1.32-2.68,8.86,8.86,0,0,0-1.26-1.36l-.37-.3Z"
                    fill="#717272"
                />
                <path
                    id="Path_207"
                    data-name="Path 207"
                    d="M219.93,354.17a8.28,8.28,0,0,0-8.92-.23A9.79,9.79,0,0,0,195.32,349a9.94,9.94,0,0,0-16.79,6.24c-3.92.21-8,2.79-8.78,7.2H223.2a8.29,8.29,0,0,0-3.27-8.27Z"
                    fill="#fff"
                />
                <path
                    id="Path_208"
                    data-name="Path 208"
                    d="M219.93,354.17s.18.11.51.36a8,8,0,0,1,1.27,1.31,8.689,8.689,0,0,1,1.36,2.63,8.16,8.16,0,0,1,.21,4v.07h-.07l-53.45.08h-.22l.05-.21.06-.25A8.54,8.54,0,0,1,173,357.1a10.42,10.42,0,0,1,5.57-2l-.16.16a10.1,10.1,0,0,1,17.07-6.33h-.2a10.08,10.08,0,0,1,5.29-2.19,9.79,9.79,0,0,1,5.12.8,10.11,10.11,0,0,1,5.46,6.38l-.13-.05a8.259,8.259,0,0,1,3.84-1.17,8.6,8.6,0,0,1,2.94.38,8.392,8.392,0,0,1,1.67.74l.51.36-.14-.07-.4-.24a8.421,8.421,0,0,0-1.67-.7,8.759,8.759,0,0,0-2.9-.33,8.061,8.061,0,0,0-3.76,1.19l-.1.06v-.12a10,10,0,0,0-5.39-6.21,9.43,9.43,0,0,0-5-.75,9.8,9.8,0,0,0-5.13,2.14l-.1.09-.1-.09a9.78,9.78,0,0,0-16.52,6.15v.15h-.15a10.1,10.1,0,0,0-5.38,1.94,8.19,8.19,0,0,0-3.18,4.87l-.06.25-.17-.21,53.45.09-.09.07a8.12,8.12,0,0,0-.18-3.94,8.46,8.46,0,0,0-2.52-3.94l-.36-.3A.52.52,0,0,1,219.93,354.17Z"
                    fill="#1a2e35"
                />
                <path
                    id="Path_209"
                    data-name="Path 209"
                    d="M339.05,352.27a8.28,8.28,0,0,0-8.91-.23,9.81,9.81,0,0,0-15.69-4.91,9.94,9.94,0,0,0-16.79,6.24c-3.92.21-8,2.8-8.79,7.2h53.45a8.28,8.28,0,0,0-3.27-8.3Z"
                    fill="#fff"
                />
                <path
                    id="Path_210"
                    data-name="Path 210"
                    d="M339.05,352.27s.18.11.51.36a8.421,8.421,0,0,1,1.28,1.31,8.689,8.689,0,0,1,1.35,2.63,8.27,8.27,0,0,1,.22,4v.07h-.07l-53.45.08h-.22l.05-.2.06-.26a8.55,8.55,0,0,1,3.32-5.08,10.39,10.39,0,0,1,5.57-2l-.16.16A10.09,10.09,0,0,1,314.55,347h-.19a10,10,0,0,1,5.28-2.19,9.71,9.71,0,0,1,5.13.81,10.12,10.12,0,0,1,5.46,6.38l-.14-.06a8.161,8.161,0,0,1,3.85-1.16,8.32,8.32,0,0,1,2.93.37,7.768,7.768,0,0,1,1.67.75,5.744,5.744,0,0,1,.51.35l-.14-.07-.39-.24a9.39,9.39,0,0,0-1.67-.7,8.63,8.63,0,0,0-2.91-.32,7.93,7.93,0,0,0-3.75,1.18l-.11.06v-.11a9.94,9.94,0,0,0-5.39-6.21,9.4,9.4,0,0,0-5-.76,9.76,9.76,0,0,0-5.13,2.15l-.1.08-.09-.09a9.78,9.78,0,0,0-16.52,6.15v.15h-.14a9.94,9.94,0,0,0-5.38,1.93,8.21,8.21,0,0,0-3.19,4.87l-.05.25-.18-.21,53.45.09-.09.07a8.079,8.079,0,0,0-.17-3.93,8.75,8.75,0,0,0-1.3-2.62,8.941,8.941,0,0,0-1.23-1.33l-.36-.29Z"
                    fill="#717272"
                />
                <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M183.93,260.9a5.38,5.38,0,0,0-5.81-.15,6.41,6.41,0,0,0-10.25-3.2,6.48,6.48,0,0,0-11,4.07,6,6,0,0,0-5.73,4.7h34.89A5.4,5.4,0,0,0,183.93,260.9Z"
                    fill="#fff"
                />
                <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M183.93,260.9a3.931,3.931,0,0,1,1.18,1.08,5.839,5.839,0,0,1,.9,1.72,5.52,5.52,0,0,1,.15,2.63v.08h-.07c-7.1,0-20.08.08-34.89.08H151v-.38a5.67,5.67,0,0,1,2.18-3.35,6.82,6.82,0,0,1,3.67-1.31l-.16.15A6.64,6.64,0,0,1,168,257.44h-.19a6.51,6.51,0,0,1,10.42,3.29l-.13-.05a5.42,5.42,0,0,1,2.52-.76,5.91,5.91,0,0,1,1.93.25,4,4,0,0,1,1.41.74,6.549,6.549,0,0,0-1.44-.64,5.571,5.571,0,0,0-1.89-.21,5.23,5.23,0,0,0-2.44.78l-.1.06v-.12a6.48,6.48,0,0,0-3.51-4,6.35,6.35,0,0,0-6.55.91l-.1.08-.1-.09a6.33,6.33,0,0,0-10.69,4v.14h-.15a6.54,6.54,0,0,0-3.48,1.25,5.26,5.26,0,0,0-2.05,3.15v.16l-.17-.21c14.81,0,27.79,0,34.89.08l-.09.08a5.28,5.28,0,0,0-.11-2.56A5.39,5.39,0,0,0,185,262a6.779,6.779,0,0,0-1.07-1.1Z"
                    fill="#717272"
                />
                <path
                    id="Path_213"
                    data-name="Path 213"
                    d="M466.34,257.91h0a12.82,12.82,0,0,1-6.25-17h0a12.8,12.8,0,0,1,17-6.25h0a12.82,12.82,0,0,1,6.25,17h0a12.82,12.82,0,0,1-17,6.25Z"
                    fill="#fff"
                />
                <path
                    id="Path_214"
                    data-name="Path 214"
                    d="M466.34,257.91a.542.542,0,0,1,.2.06l.57.21a6.462,6.462,0,0,0,.94.31,10.709,10.709,0,0,0,1.31.3,12,12,0,0,0,3.67.12,12.677,12.677,0,0,0,11.28-11.56,12.09,12.09,0,0,0-.23-3.63,13.56,13.56,0,0,0-.5-1.81,15.176,15.176,0,0,0-.81-1.74,12.57,12.57,0,0,0-13.57-6.27,14.441,14.441,0,0,0-1.85.51,14.733,14.733,0,0,0-1.71.79,11.919,11.919,0,0,0-2.91,2.18,12.72,12.72,0,0,0-1.5,16.08,12,12,0,0,0,2.47,2.72,9.879,9.879,0,0,0,1.08.8,7.008,7.008,0,0,0,.84.52l.54.3a1.15,1.15,0,0,1,.17.11l-.19-.08-.55-.27a5.79,5.79,0,0,1-.86-.49,9.6,9.6,0,0,1-1.11-.78,12.329,12.329,0,0,1-2.55-2.72,12.966,12.966,0,0,1,1.43-16.46,12.36,12.36,0,0,1,3-2.25,16.439,16.439,0,0,1,1.75-.81,15.248,15.248,0,0,1,1.9-.53A12.93,12.93,0,0,1,483.08,240a15.108,15.108,0,0,1,.83,1.78,16.245,16.245,0,0,1,.51,1.87,12.329,12.329,0,0,1,.22,3.72,12.9,12.9,0,0,1-11.59,11.73,12.36,12.36,0,0,1-3.71-.18,10,10,0,0,1-1.32-.34,6.74,6.74,0,0,1-.93-.34l-.56-.25A.189.189,0,0,1,466.34,257.91Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_215"
                    data-name="Path 215"
                    d="M472.79,246.62a3.13,3.13,0,0,0,2.92-1.85,3,3,0,1,0-5.35-2.5,3.13,3.13,0,0,0,.48,3.45c-4.42-1.28-6.3,3.29-6.3,3.29l9.73,4.55S476.59,249.13,472.79,246.62Z"
                    fill="#717272"
                />
                <path
                    id="Path_216"
                    data-name="Path 216"
                    d="M346.52,250h0a15.54,15.54,0,0,1-21.91-1.74h0a15.56,15.56,0,0,1,1.74-21.91h0a15.53,15.53,0,0,1,21.9,1.74h0A15.54,15.54,0,0,1,346.52,250Z"
                    fill="#fff"
                />
                <path
                    id="Path_217"
                    data-name="Path 217"
                    d="M346.52,250a1.73,1.73,0,0,1,.17-.19l.52-.52.39-.38c.14-.14.28-.32.43-.49a11.637,11.637,0,0,0,1-1.29,15.18,15.18,0,0,0,2-4,15.571,15.571,0,0,0,.77-5.83,15.4,15.4,0,0,0-7.78-12.5,16.413,16.413,0,0,0-2-.95,15.149,15.149,0,0,0-2.14-.65,18.361,18.361,0,0,0-2.26-.37,16.489,16.489,0,0,0-2.33,0,14.681,14.681,0,0,0-4.65,1.07,16.471,16.471,0,0,0-4.2,2.54,16.671,16.671,0,0,0-3.18,3.75,15.049,15.049,0,0,0-1.79,4.42,16.71,16.71,0,0,0-.38,2.3,15.914,15.914,0,0,0,0,2.29,16.235,16.235,0,0,0,.3,2.22,16,16,0,0,0,.63,2.1,15.32,15.32,0,0,0,11.11,9.66A15.52,15.52,0,0,0,343.29,252a12.227,12.227,0,0,0,1.43-.79c.2-.12.39-.23.55-.34l.44-.33.6-.43c.13-.1.2-.15.21-.14l-.19.17-.58.46-.43.34c-.16.12-.35.23-.55.36a11.165,11.165,0,0,1-1.42.82,14.889,14.889,0,0,1-4.28,1.42,15.591,15.591,0,0,1-17.32-9.9,15.148,15.148,0,0,1-.65-2.14,15.309,15.309,0,0,1-.31-2.27,16.474,16.474,0,0,1,0-2.33,19,19,0,0,1,.38-2.36A15.21,15.21,0,0,1,323,230a15.53,15.53,0,0,1,7.54-6.43,15.329,15.329,0,0,1,4.75-1.1,17.33,17.33,0,0,1,2.39,0,17.651,17.651,0,0,1,2.31.37,14.751,14.751,0,0,1,4.2,1.65,15.6,15.6,0,0,1,7,18.67,14.708,14.708,0,0,1-2.08,4,11.467,11.467,0,0,1-1,1.27c-.16.18-.3.35-.44.49l-.41.37-.55.5Z"
                    fill="#717272"
                />
                <path
                    id="Path_218"
                    data-name="Path 218"
                    d="M337.36,237.14a3.81,3.81,0,0,0-.56-4.16,3.58,3.58,0,1,0-5.47,4.61,3.81,3.81,0,0,0,4.05,1.24c-3.66,4.2.42,8.6.42,8.6l9.95-8.41S342.05,234.22,337.36,237.14Z"
                    fill="#717272"
                />
                <path
                    id="Path_219"
                    data-name="Path 219"
                    d="M254.92,184.65h0a9.88,9.88,0,0,1-3.49-13.53h0A9.88,9.88,0,0,1,265,167.63h0a9.88,9.88,0,0,1,3.49,13.53h0a9.88,9.88,0,0,1-13.57,3.49Z"
                    fill="#fff"
                />
                <path
                    id="Path_220"
                    data-name="Path 220"
                    d="M254.92,184.65a17.222,17.222,0,0,0,2.26.9,9.809,9.809,0,0,0,12.32-7.62,9.279,9.279,0,0,0,.1-2.79,9.18,9.18,0,0,0-.73-2.82,9.71,9.71,0,0,0-9.89-5.84,9.28,9.28,0,0,0-2.83.72,9,9,0,0,0-2.39,1.45,9.79,9.79,0,0,0-.71,14.46,16.1,16.1,0,0,0,1.87,1.54l-.14-.07-.4-.24a4.492,4.492,0,0,1-.63-.45,6.318,6.318,0,0,1-.8-.68,9.229,9.229,0,0,1-1.75-2.28,10.026,10.026,0,0,1,2.32-12.53,9.46,9.46,0,0,1,2.46-1.51,9.89,9.89,0,0,1,2.92-.75,10,10,0,0,1,10.24,6.05,9.47,9.47,0,0,1,.75,2.91,9.3,9.3,0,0,1-.12,2.89,9.959,9.959,0,0,1-9.83,8.12,9.33,9.33,0,0,1-2.84-.43,6.484,6.484,0,0,1-1-.37,4.49,4.49,0,0,1-.69-.33l-.41-.24C255,184.69,254.92,184.66,254.92,184.65Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_221"
                    data-name="Path 221"
                    d="M260.74,176.49a2.42,2.42,0,0,0,2.38-1.2,2.28,2.28,0,1,0-3.91-2.33,2.43,2.43,0,0,0,.1,2.69c-3.29-1.33-5.09,2-5.09,2l7.12,4.25S263.46,178.71,260.74,176.49Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_5"
                    data-name="Ellipse 5"
                    cx="23.89"
                    cy="23.89"
                    r="23.89"
                    transform="translate(385.807 146.46) rotate(-26.82)"
                    fill="#fff"
                />
                <path
                    id="Path_222"
                    data-name="Path 222"
                    d="M427.74,149.52a6.43,6.43,0,0,0-2.11-4.5,8.06,8.06,0,0,0-5.15-1.89A17.27,17.27,0,0,0,415,144a8.65,8.65,0,0,0-2.84,1.31,12,12,0,0,0-3.76,5.14,21.311,21.311,0,0,0-.44,6.89,3.44,3.44,0,0,0,1.14,1.64,12.9,12.9,0,0,0,1.87,4.24c.59-.92,1.17-1.85,1.76-2.78Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_223"
                    data-name="Path 223"
                    d="M427.31,147.37l-2.84-1.22c.71,4.23-.93,13.15-1,17.45,1.46-1.33,5.13-5.55,5.45-7.51S430.9,147.88,427.31,147.37Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_224"
                    data-name="Path 224"
                    d="M411.75,150.48a5.21,5.21,0,0,1,4.91-3.76l7.23-.13c3,.38,4.13,4.46,3.63,7.47a48.38,48.38,0,0,1-2.21,9.2c-1.93,4.75-5.86,4.49-5.86,4.49l-.9,3.79-2.8,6.12-8-6.22,4-20.9C411.74,150.45,411.72,150.59,411.75,150.48Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_225"
                    data-name="Path 225"
                    d="M425,157.74a.65.65,0,0,1-.76.49.62.62,0,0,1-.52-.72.65.65,0,0,1,.76-.5.64.64,0,0,1,.52.73Z"
                    fill="#717272"
                />
                <path
                    id="Path_226"
                    data-name="Path 226"
                    d="M426.32,155.82c-.1.06-.49-.41-1.17-.56a5.674,5.674,0,0,0-1.32,0c-.06-.06.09-.17.34-.28a1.78,1.78,0,0,1,1.08-.08,1.84,1.84,0,0,1,.91.55C426.33,155.62,426.37,155.79,426.32,155.82Z"
                    fill="#717272"
                />
                <path
                    id="Path_227"
                    data-name="Path 227"
                    d="M418.87,156.12a.65.65,0,0,1-.76.5.64.64,0,0,1-.52-.73.65.65,0,0,1,.76-.49.61.61,0,0,1,.52.72Z"
                    fill="#717272"
                />
                <path
                    id="Path_228"
                    data-name="Path 228"
                    d="M419.86,154.29c-.1.07-.5-.4-1.18-.56a5.551,5.551,0,0,0-1.31,0c-.05-.07.08-.18.34-.28a1.78,1.78,0,0,1,1.08-.08,1.71,1.71,0,0,1,.91.55C419.87,154.1,419.91,154.26,419.86,154.29Z"
                    fill="#717272"
                />
                <path
                    id="Path_229"
                    data-name="Path 229"
                    d="M420.73,160.14a4.769,4.769,0,0,1,1.15.06c.18,0,.35,0,.41-.09a.88.88,0,0,0,0-.54c-.06-.46-.13-.94-.2-1.44a23.323,23.323,0,0,1-.35-3.74,24.543,24.543,0,0,1,.65,3.7c.06.5.12,1,.18,1.45a1,1,0,0,1-.07.7.48.48,0,0,1-.35.19,1.32,1.32,0,0,1-.3,0,4.209,4.209,0,0,1-1.12-.29Z"
                    fill="#717272"
                />
                <path
                    id="Path_230"
                    data-name="Path 230"
                    d="M413.32,164.46s.81,3.76,5.85,4.45l.28-1.16a12.77,12.77,0,0,1-6.13-3.29Z"
                    fill="#717272"
                    opacity="0.5"
                />
                <path
                    id="Path_231"
                    data-name="Path 231"
                    d="M420.22,151.78c-.11.17-.76-.07-1.59-.16s-1.51,0-1.58-.22.12-.24.42-.35a2.65,2.65,0,0,1,1.25-.14,2.58,2.58,0,0,1,1.17.43C420.16,151.52,420.27,151.7,420.22,151.78Z"
                    fill="#717272"
                />
                <path
                    id="Path_232"
                    data-name="Path 232"
                    d="M426.59,153.68c-.15.13-.59-.14-1.15-.28s-1.06-.14-1.14-.33.08-.22.33-.32a1.62,1.62,0,0,1,1,0,1.64,1.64,0,0,1,.85.53C426.63,153.44,426.66,153.62,426.59,153.68Z"
                    fill="#717272"
                />
                <path
                    id="Path_233"
                    data-name="Path 233"
                    d="M427.24,149.24a2.25,2.25,0,0,0-1.63-1.68,4.29,4.29,0,0,0-2.43.13c-3.33,1-5.81,4.75-9.13,5.82-.81.26-1.65-.35-2.39.08a2.17,2.17,0,0,0-1.2,2.09,7,7,0,0,1-.6-1.94,2.38,2.38,0,0,1,.53-1.9c.36-.38.88-.61,1.12-1.07a7.171,7.171,0,0,0,.26-1.32,3.059,3.059,0,0,1,.75-1.16,13.09,13.09,0,0,1,5.88-3.84,8.56,8.56,0,0,1,4.6-.1,6.52,6.52,0,0,1,3.73,2.6c.51.76,1,1.55.51,2.29"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_234"
                    data-name="Path 234"
                    d="M411.59,154.21a1.77,1.77,0,0,0-3,1,2.05,2.05,0,0,0,2.16,2.69C410.73,157.86,411.59,154.21,411.59,154.21Z"
                    fill="#e3e2e2"
                />
                <g id="Group_125" data-name="Group 125" opacity="0.5">
                    <path
                        id="Path_235"
                        data-name="Path 235"
                        d="M410.13,156.73h-.14a.5.5,0,0,1-.35-.08,1.16,1.16,0,0,1-.27-1.15,1.53,1.53,0,0,1,.29-.63.54.54,0,0,1,.43-.27.23.23,0,0,1,.24.19v.14c0,.01.06,0,.07-.15a.41.41,0,0,0-.06-.19.47.47,0,0,0-.24-.13.69.69,0,0,0-.59.3,1.66,1.66,0,0,0-.34.69,1.27,1.27,0,0,0,.39,1.32.53.53,0,0,0,.44,0C410.11,156.79,410.14,156.74,410.13,156.73Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_236"
                    data-name="Path 236"
                    d="M410.85,152.6h.18a1.884,1.884,0,0,0,.52-.18,9.32,9.32,0,0,0,1.74-1,29,29,0,0,0,2.29-1.86,21.379,21.379,0,0,1,2.83-2.21,8.522,8.522,0,0,1,1.68-.79,6.921,6.921,0,0,1,1.69-.33,7.689,7.689,0,0,1,2.9.32,7.39,7.39,0,0,1,1.8.81c.2.12.34.23.45.3l.15.1s0-.05-.14-.12a3.659,3.659,0,0,0-.44-.32,7.211,7.211,0,0,0-1.8-.86,7.759,7.759,0,0,0-2.93-.35,7.24,7.24,0,0,0-1.72.33,8.459,8.459,0,0,0-1.7.8,21.219,21.219,0,0,0-2.85,2.23,27.6,27.6,0,0,1-2.26,1.88,10.791,10.791,0,0,1-1.71,1l-.51.19Z"
                    opacity="0.5"
                />
                <path
                    id="Path_237"
                    data-name="Path 237"
                    d="M411.34,153.51a4.27,4.27,0,0,0-.24,2.2,1.45,1.45,0,0,0,1.64,1.15,2.12,2.12,0,0,0,1.12-1.36c.65-1.64,1.17-3.32,1.83-4.95Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_238"
                    data-name="Path 238"
                    d="M426.88,147.82a4.4,4.4,0,0,0-.64-.21,4.68,4.68,0,0,0-1.84-.1,6.33,6.33,0,0,0-1.23.31A14.08,14.08,0,0,0,419,150.3c-.45.39-.86.81-1.29,1.18a7.371,7.371,0,0,1-1.35,1,12.068,12.068,0,0,1-2.6,1c-.77.2-1.39.32-1.83.4l-.5.09h-.17l.17-.05.49-.11c.43-.1,1.05-.23,1.81-.44a12.771,12.771,0,0,0,2.56-1,6.74,6.74,0,0,0,1.32-.93c.42-.37.83-.79,1.29-1.19a13.439,13.439,0,0,1,2.82-1.88,12.186,12.186,0,0,1,1.37-.6,5.28,5.28,0,0,1,1.26-.29,4.47,4.47,0,0,1,1.86.14,2.928,2.928,0,0,1,.48.18Z"
                    fill="#375a64"
                />
                <path
                    id="Path_239"
                    data-name="Path 239"
                    d="M411.66,151.85a1,1,0,0,1-.28.1l-.76.24-.26.08a1.05,1.05,0,0,1-.31,0,.32.32,0,0,1-.17-.09.24.24,0,0,1-.06-.2.66.66,0,0,1,.2-.3l1.08-1.07.08.12a2.76,2.76,0,0,1-.95.23,2.67,2.67,0,0,1-1-.12.92.92,0,0,1-.23-.09.33.33,0,0,1-.16-.23.29.29,0,0,1,.1-.26,1.624,1.624,0,0,1,.19-.13,5.64,5.64,0,0,0,1.18-.93,8.887,8.887,0,0,0,.86-1.09,1.05,1.05,0,0,1-.17.34,5.268,5.268,0,0,1-.61.83,5.721,5.721,0,0,1-1.18,1c-.12.07-.25.16-.23.25s.15.17.29.2a2.78,2.78,0,0,0,1.83-.11l.37-.15-.29.28-1.08,1.05a.52.52,0,0,0-.18.23.13.13,0,0,0,.13.15,1.53,1.53,0,0,0,.52-.08l.78-.2a1.139,1.139,0,0,1,.31-.05Z"
                    opacity="0.5"
                />
                <path
                    id="Path_240"
                    data-name="Path 240"
                    d="M417.84,160.78a.92.92,0,0,1,1.08-.45,1,1,0,0,1,.59.67,1.14,1.14,0,0,1-.17.9v.06a.987.987,0,0,1-1.5-1.18Z"
                    fill="#717272"
                    opacity="0.5"
                />
                <path
                    id="Path_241"
                    data-name="Path 241"
                    d="M419.8,162.09c0-.1-.67-.23-1.05-.92s-.17-1.41-.27-1.44-.16.15-.23.46a1.77,1.77,0,0,0,.18,1.19,1.58,1.58,0,0,0,.9.73C419.61,162.19,419.8,162.14,419.8,162.09Z"
                    fill="#717272"
                />
                <path
                    id="Path_242"
                    data-name="Path 242"
                    d="M426.35,175.31a14.36,14.36,0,0,0-3-2.67l-4.57-2.29a5.36,5.36,0,0,1-6,1.72,7,7,0,0,1-4.44-4.69s-6.47-.84-11.2,1.67a24,24,0,0,0,31.28,9.47,27.993,27.993,0,0,0-2.07-3.21Z"
                    fill="#717272"
                />
                <path
                    id="Path_243"
                    data-name="Path 243"
                    d="M394.93,163.08s.05.12.13.37.2.61.36,1.08l.25.8c.11.29.25.6.4.94a17,17,0,0,0,1.09,2.28,22.821,22.821,0,0,0,4.14,5.52,23.929,23.929,0,0,0,7.56,5.07A23.67,23.67,0,0,0,419.7,181a24.368,24.368,0,0,0,3-.4c.5-.11,1-.19,1.52-.33l1.51-.46c.25-.09.51-.15.76-.25l.74-.31c.5-.22,1-.41,1.49-.65a25.233,25.233,0,0,0,2.86-1.69,23.888,23.888,0,0,0,2.68-2.09c.42-.38.81-.81,1.22-1.22a12,12,0,0,0,1.15-1.31,26.143,26.143,0,0,0,2.06-2.9,27.193,27.193,0,0,0,1.59-3.25,23.3,23.3,0,0,0,1.69-7.2,23.57,23.57,0,0,0-3.69-14.59l-1.06-1.56-1.2-1.43a5.775,5.775,0,0,0-.63-.68l-.65-.65-.66-.64-.71-.58a27.272,27.272,0,0,0-2.95-2.1,26.929,26.929,0,0,0-3.19-1.57,11.833,11.833,0,0,0-1.63-.61c-.56-.16-1.11-.35-1.66-.49a24.689,24.689,0,0,0-3.35-.57,26.516,26.516,0,0,0-3.32-.12c-.54,0-1.08.09-1.62.14l-.8.08a4.262,4.262,0,0,0-.78.14l-1.55.31c-.51.12-1,.29-1.5.44a21.91,21.91,0,0,0-2.84,1.08,23.65,23.65,0,0,0-8.65,6.78,24,24,0,0,0-4.23,8.07,22.91,22.91,0,0,0-1,6.82,19.172,19.172,0,0,0,.12,2.52,7.03,7.03,0,0,0,.1,1l.16.83c.09.48.15.86.2,1.12a3.938,3.938,0,0,1,.06.39l-.09-.38c-.06-.26-.14-.64-.24-1.12-.05-.25-.11-.52-.18-.82a9.548,9.548,0,0,1-.11-1,17.181,17.181,0,0,1-.16-2.53,23.131,23.131,0,0,1,1-6.88,23.82,23.82,0,0,1,15.82-16.16c.5-.14,1-.32,1.51-.45l1.57-.31a7.5,7.5,0,0,0,.8-.15l.81-.08c.54-.05,1.09-.12,1.64-.15a27.091,27.091,0,0,1,3.36.12,25.129,25.129,0,0,1,3.4.57c.56.14,1.11.33,1.68.5a12.729,12.729,0,0,1,1.66.61,26.108,26.108,0,0,1,3.23,1.59,25.789,25.789,0,0,1,3,2.13l.73.59.66.65.67.65a6,6,0,0,1,.64.69l1.22,1.46,1.07,1.57a23.91,23.91,0,0,1,3.75,14.8,23.332,23.332,0,0,1-1.73,7.31,22,22,0,0,1-3.7,6.23,13.41,13.41,0,0,1-1.17,1.33c-.42.41-.81.84-1.24,1.24a26.278,26.278,0,0,1-5.62,3.81c-.49.24-1,.44-1.51.65l-.75.32c-.25.1-.52.16-.77.25l-1.53.47c-.51.13-1,.21-1.55.32a22.745,22.745,0,0,1-3.05.4,24.15,24.15,0,0,1-18.55-7.09,22.639,22.639,0,0,1-4.12-5.59,16.817,16.817,0,0,1-1.07-2.3c-.14-.34-.28-.65-.38-.95l-.24-.81c-.14-.47-.24-.83-.32-1.1A1.66,1.66,0,0,0,394.93,163.08Z"
                    fill="#5b5b5b"
                />
                <circle
                    id="Ellipse_6"
                    data-name="Ellipse 6"
                    cx="34.77"
                    cy="34.77"
                    r="34.77"
                    transform="translate(366.612 236.02) rotate(-45)"
                    fill="#fff"
                />
                <path
                    id="Path_244"
                    data-name="Path 244"
                    d="M432.22,233.7c-.19-3.3.1-6.61-.26-9.89s-1.47-6.64-3.93-8.84-6.51-2.81-9.06-.72l-.35,2.84q2.94,18.91,5.86,37.83a13,13,0,0,0,1.4,4.8,4.43,4.43,0,0,0,4.13,2.34c2.17-.29,3.45-2.61,4-4.73C435.92,249.61,432.69,241.63,432.22,233.7Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_245"
                    data-name="Path 245"
                    d="M423.1,217.2a9,9,0,0,0-1.83-2.15,3.14,3.14,0,0,0-2.65-.68,1.28,1.28,0,0,0-1,.82c-.12.43.23,1,.67.9l.1.07c1.05.8,2.11,1.59,3.19,2.35a2.65,2.65,0,0,0,.88.46.88.88,0,0,0,.9-.27C423.73,218.27,423.42,217.65,423.1,217.2Z"
                />
                <path
                    id="Path_246"
                    data-name="Path 246"
                    d="M425.19,220.3a16.63,16.63,0,0,0-13.31-5.49c-2.92.15-4.09.85-6.15,1.56a9.24,9.24,0,0,0-5,3.85,15.52,15.52,0,0,0-2.53,7.27,43.411,43.411,0,0,0,.19,8,14.51,14.51,0,0,0,3,7.3l6.83.69a42.15,42.15,0,0,0,11.09-1.39c3.57-1.1,6.95-3.3,8.67-6.62C430.36,230.84,428.75,224.07,425.19,220.3Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_247"
                    data-name="Path 247"
                    d="M409,255.44c-.12-2.37-.25-5.35-.25-5.34s-5.54-.21-7.56-7.15c-1-3.46-1.56-9.25-1.85-14-.27-4.28,3-10.37,8.25-10.76l2.32-.44,9.25,2.94a2.51,2.51,0,0,1,2.55,2.24l2.53,31-5.08,10-10.88-7.25Z"
                    fill="#e3e2e2"
                />
                <g id="Group_126" data-name="Group 126" opacity="0.3">
                    <path
                        id="Path_248"
                        data-name="Path 248"
                        d="M411.67,240.55a1.48,1.48,0,0,0-.58-.89,1.55,1.55,0,0,0-1.87,0,2.06,2.06,0,0,0-.64,2h0a1.89,1.89,0,0,0,1.39.68h.25a1.69,1.69,0,0,0,1.1-.53,1.47,1.47,0,0,0,.35-1.26Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_249"
                    data-name="Path 249"
                    d="M402.59,234.23a.91.91,0,0,0,1,.81.88.88,0,0,0,.84-.94.91.91,0,0,0-1-.8.87.87,0,0,0-.84.93Z"
                    fill="#717272"
                />
                <path
                    id="Path_250"
                    data-name="Path 250"
                    d="M401.15,231.2c.12.11.75-.49,1.73-.61s1.75.28,1.84.14-.09-.25-.44-.44a2.46,2.46,0,0,0-1.49-.26,2.4,2.4,0,0,0-1.36.63C401.16,230.93,401.08,231.16,401.15,231.2Z"
                    fill="#717272"
                />
                <path
                    id="Path_251"
                    data-name="Path 251"
                    d="M408,238.45a7.19,7.19,0,0,0-1.63-.08c-.25,0-.49,0-.56-.18a1.25,1.25,0,0,1,.08-.76c.16-.64.32-1.3.5-2a33.814,33.814,0,0,0,1-5.18,31.718,31.718,0,0,0-1.45,5.09c-.16.7-.32,1.36-.47,2a1.46,1.46,0,0,0,0,1,.65.65,0,0,0,.46.32,1.54,1.54,0,0,0,.43,0,6.24,6.24,0,0,0,1.64-.21Z"
                    fill="#717272"
                />
                <g id="Group_127" data-name="Group 127" opacity="0.5">
                    <path
                        id="Path_252"
                        data-name="Path 252"
                        d="M408.78,250.1a18.17,18.17,0,0,0,9.17-3.72s-1.91,5.23-9.08,5.46Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_253"
                    data-name="Path 253"
                    d="M411,238.77c-.16,0,0,1.07-.84,1.94a5.094,5.094,0,0,1-1.95,1c.05.11.28.17.76.13a2.67,2.67,0,0,0,1.63-.82,2.32,2.32,0,0,0,.64-1.61A1.315,1.315,0,0,0,411,238.77Z"
                    fill="#717272"
                />
                <path
                    id="Path_254"
                    data-name="Path 254"
                    d="M401.24,227.74c.19.22.92,0,1.8-.07s1.64.1,1.81-.14-.06-.34-.39-.54a2.71,2.71,0,0,0-1.48-.32,2.65,2.65,0,0,0-1.43.49C401.25,227.4,401.15,227.64,401.24,227.74Z"
                    fill="#717272"
                />
                <path
                    id="Path_255"
                    data-name="Path 255"
                    d="M413.74,233.2a.91.91,0,0,1-.8,1,.87.87,0,0,1-1-.74.91.91,0,0,1,.8-1,.86.86,0,0,1,1,.74Z"
                    fill="#717272"
                />
                <path
                    id="Path_256"
                    data-name="Path 256"
                    d="M414.4,229.88c-.1.13-.84-.32-1.82-.23s-1.66.65-1.78.53,0-.27.34-.53a2.52,2.52,0,0,1,1.4-.57,2.47,2.47,0,0,1,1.47.33C414.33,229.62,414.45,229.83,414.4,229.88Z"
                    fill="#717272"
                />
                <path
                    id="Path_257"
                    data-name="Path 257"
                    d="M413.59,226.78c-.18.24-1,.08-1.87.15s-1.66.29-1.86.08,0-.34.33-.58a2.81,2.81,0,0,1,1.48-.5,2.74,2.74,0,0,1,1.52.31C413.54,226.45,413.66,226.67,413.59,226.78Z"
                    fill="#717272"
                />
                <path
                    id="Path_258"
                    data-name="Path 258"
                    d="M421.36,235c-.07-.53.39-1.85.9-2,1.36-.39,3.88-.59,4.35,2.94.64,4.82-4.33,4.47-4.36,4.33S421.58,236.78,421.36,235Z"
                    fill="#e3e2e2"
                />
                <g id="Group_128" data-name="Group 128" opacity="0.5">
                    <path
                        id="Path_259"
                        data-name="Path 259"
                        d="M423.35,238.29a1.552,1.552,0,0,0,.24.1.87.87,0,0,0,.63-.08,2.1,2.1,0,0,0,.71-2,2.7,2.7,0,0,0-.39-1.17,1,1,0,0,0-.72-.56.44.44,0,0,0-.47.29c0,.15,0,.24,0,.25s-.12-.07-.11-.27a.57.57,0,0,1,.15-.33.63.63,0,0,1,.45-.18,1.17,1.17,0,0,1,1,.63,2.889,2.889,0,0,1,.47,1.31,2.19,2.19,0,0,1-.95,2.24.89.89,0,0,1-.78,0C423.37,238.41,423.33,238.3,423.35,238.29Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_260"
                    data-name="Path 260"
                    d="M422.46,233l-1.14,1.37c-5.68-4.72-17-16.73-16.34-16a15.6,15.6,0,0,1,7.54-1.36c4,.4,11.64,1.84,11.85,6.51a24.3,24.3,0,0,1-1.91,9.48Z"
                    fill="#5b5b5b"
                />
                <g id="Group_129" data-name="Group 129" opacity="0.5">
                    <path
                        id="Path_261"
                        data-name="Path 261"
                        d="M429.42,231.39a1,1,0,0,0-.09-.27,4.193,4.193,0,0,0-.39-.74,7,7,0,0,0-2.18-2.14,13.57,13.57,0,0,0-4.22-1.67,54.458,54.458,0,0,1-5.36-1.34,23.411,23.411,0,0,1-5-2.34,24.8,24.8,0,0,1-3.59-2.72,28.389,28.389,0,0,1-2.12-2.18c-.21-.26-.39-.47-.53-.63s-.19-.22-.2-.21a2.564,2.564,0,0,0,.16.24c.11.15.27.38.5.66a21.254,21.254,0,0,0,2.07,2.25,23.58,23.58,0,0,0,8.61,5.17,53.842,53.842,0,0,0,5.39,1.32,13.4,13.4,0,0,1,4.17,1.6,7.25,7.25,0,0,1,2.2,2A11.422,11.422,0,0,1,429.42,231.39Z"
                    />
                </g>
                <g id="Group_130" data-name="Group 130" opacity="0.5">
                    <path
                        id="Path_262"
                        data-name="Path 262"
                        d="M428.07,232.26a2.55,2.55,0,0,0-.27-1,5,5,0,0,0-2-2.15,10.85,10.85,0,0,0-4.16-1.3,24.16,24.16,0,0,1-5.13-1.24,21.261,21.261,0,0,1-4.68-2.45,21.5,21.5,0,0,1-3.28-2.8,22.272,22.272,0,0,1-1.88-2.23l-.46-.65c-.11-.15-.17-.23-.18-.22a1.82,1.82,0,0,0,.14.24l.42.68a18.307,18.307,0,0,0,1.83,2.3,21.12,21.12,0,0,0,3.28,2.87,20.618,20.618,0,0,0,4.72,2.49,23.61,23.61,0,0,0,5.19,1.24,10.9,10.9,0,0,1,4.1,1.22,5,5,0,0,1,2,2,6.466,6.466,0,0,1,.36,1Z"
                    />
                </g>
                <g id="Group_131" data-name="Group 131" opacity="0.5">
                    <path
                        id="Path_263"
                        data-name="Path 263"
                        d="M422.88,241.18s.4-.12,1.11-.36a6.9,6.9,0,0,0,2.6-1.7,9.83,9.83,0,0,0,2.25-4,16.851,16.851,0,0,0,.65-5.66,14.369,14.369,0,0,0-.44-2.92,13.727,13.727,0,0,0-1-2.57,14.07,14.07,0,0,0-2.79-3.74,22.758,22.758,0,0,0-3.45-2.6,1,1,0,0,1,.28.12c.17.09.44.21.76.41a14.582,14.582,0,0,1,2.57,1.91,13.33,13.33,0,0,1,4.38,9.37,16.7,16.7,0,0,1-.69,5.77,9.849,9.849,0,0,1-2.37,4.11,6.66,6.66,0,0,1-2.72,1.66,6.368,6.368,0,0,1-.85.2A1,1,0,0,1,422.88,241.18Z"
                    />
                </g>
                <path
                    id="Path_264"
                    data-name="Path 264"
                    d="M438,255.21c-2.33-1.33-6.13-1.36-6.13-1.36l-7.42-.51s-3.65,5.89-9.19,5.87-6.4-3.68-6.4-3.68-9.25,2.19-14.19,8.22A34.91,34.91,0,0,0,442,258.88a12.84,12.84,0,0,0-4-3.67Z"
                    fill="#717272"
                />
                <path
                    id="Path_265"
                    data-name="Path 265"
                    d="M450.47,233.56l-.09-.55-.21-1.64c-.05-.37-.1-.77-.16-1.21s-.2-.92-.32-1.44-.25-1.07-.38-1.67a5.5,5.5,0,0,0-.27-.91l-.32-.95a33,33,0,0,0-4.49-8.94,34.62,34.62,0,0,0-9.48-9.19l-1.57-1c-.55-.31-1.12-.59-1.69-.89a15.038,15.038,0,0,0-1.76-.85l-1.85-.74c-.32-.12-.63-.25-.95-.36l-1-.28-2-.58c-.68-.17-1.38-.26-2.08-.4a16.684,16.684,0,0,0-2.12-.32,30.53,30.53,0,0,0-4.4-.2c-.75,0-1.51,0-2.26.07l-2.28.28c-.38.05-.77.08-1.15.16l-1.14.25c-.75.19-1.53.33-2.29.55a36.6,36.6,0,0,0-4.51,1.67l-1.12.5-.55.26-.54.3-2.15,1.24c-.7.44-1.37.95-2.06,1.43a10.858,10.858,0,0,0-1,.75l-1,.84a37.84,37.84,0,0,0-3.68,3.6L388,215.4l-.41.51-.36.56-.71,1.11-.72,1.12-.62,1.18-.61,1.2-.31.59c-.09.21-.17.42-.25.63-.33.83-.67,1.67-1,2.51s-.5,1.75-.76,2.63a34.3,34.3,0,0,0,1.54,21.78l1.12,2.49,1.34,2.35.34.59.39.54.77,1.1.78,1.09.87,1,.86,1,.44.5.47.45,1.89,1.81a39.33,39.33,0,0,0,4.16,3.06l1.07.68a11.875,11.875,0,0,0,1.11.6c.75.38,1.49.79,2.24,1.14l2.31.91.57.23.59.18,1.18.34a36.859,36.859,0,0,0,4.7,1c.78.11,1.57.14,2.35.21l1.16.1h3.45c.76-.05,1.51-.17,2.25-.25a32.14,32.14,0,0,0,4.33-.81,17.555,17.555,0,0,0,2.06-.63c.67-.23,1.35-.42,2-.69l1.9-.84.93-.42.88-.5,1.74-1c.57-.32,1.08-.74,1.61-1.1s1.06-.73,1.56-1.11l1.41-1.22a34.58,34.58,0,0,0,8.09-10.43,33.211,33.211,0,0,0,3.19-9.48l.18-1a5.18,5.18,0,0,0,.13-.94q.09-.91.15-1.71c0-.52.1-1,.12-1.46s0-.85,0-1.22v-1.65c0,.38,0,.93.05,1.65V237c0,.45-.06.94-.1,1.47s-.08,1.11-.13,1.72a6.368,6.368,0,0,1-.12.94q-.09.48-.18,1a33.079,33.079,0,0,1-3.14,9.55,34.63,34.63,0,0,1-8.11,10.52l-1.42,1.24c-.5.38-1,.74-1.56,1.12a14.578,14.578,0,0,1-1.63,1.11l-1.74,1-.89.5-.94.43-1.9.85c-.65.27-1.34.47-2,.7a18.532,18.532,0,0,1-2.08.64,32.6,32.6,0,0,1-4.36.83c-.75.08-1.5.21-2.27.25l-2.31.05h-1.17l-1.18-.1c-.78-.07-1.58-.1-2.37-.21a34.613,34.613,0,0,1-4.74-1l-1.19-.34-.59-.17-.58-.23-2.33-.93c-.77-.34-1.51-.76-2.26-1.14-.38-.2-.77-.37-1.13-.6l-1.08-.69a38.617,38.617,0,0,1-4.2-3.08L391,260.57l-.48-.45-.44-.51-.87-1-.88-1-.78-1.1-.79-1.1-.39-.56-.34-.59-1.36-2.37-1.13-2.52a34.5,34.5,0,0,1-1.55-22l.76-2.65c.34-.85.68-1.7,1-2.54l.26-.63.31-.6.62-1.21.62-1.19.73-1.13.72-1.13.36-.55.41-.53,1.64-2.07a39.873,39.873,0,0,1,3.72-3.64l1-.84c.32-.28.69-.5,1-.75.7-.49,1.37-1,2.08-1.45l2.18-1.24.54-.31.56-.26,1.13-.5a37.294,37.294,0,0,1,4.55-1.69c.77-.21,1.55-.36,2.32-.54l1.15-.26c.38-.08.77-.1,1.16-.15l2.3-.28c.76-.07,1.52,0,2.27-.07a32.539,32.539,0,0,1,4.44.21,16.731,16.731,0,0,1,2.14.33c.71.14,1.41.24,2.09.41l2,.58,1,.29,1,.37,1.87.75c.62.23,1.18.58,1.76.86s1.16.59,1.71.9l1.58,1a34.52,34.52,0,0,1,9.5,9.28,32.83,32.83,0,0,1,4.46,9c.11.33.21.65.32,1a5.392,5.392,0,0,1,.25.91c.13.6.26,1.16.37,1.68s.24,1,.31,1.44.1.85.14,1.22c.08.71.14,1.26.18,1.64A1.117,1.117,0,0,1,450.47,233.56Z"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_7"
                    data-name="Ellipse 7"
                    cx="22.38"
                    cy="22.38"
                    r="22.38"
                    transform="matrix(0.035, -0.999, 0.999, 0.035, 333.686, 195.015)"
                    fill="#fff"
                />
                <path
                    id="Path_266"
                    data-name="Path 266"
                    d="M352.16,184.92v-2.71s-4.72-.44-5.06-5.11c-.16-2.26-.12-6.93,0-11.16a8.71,8.71,0,0,1,8.2-8.52h.45c4.87,0,7.61,4.13,7.48,9L363,184.7l-7.87,6.3h-.58Z"
                    fill="#e3e2e2"
                />
                <g id="Group_132" data-name="Group 132" opacity="0.5">
                    <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M352.15,182.21a11.27,11.27,0,0,0,6-2.16s-1.28,3.5-6,3.36Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_268"
                    data-name="Path 268"
                    d="M355,168c.09.09.63-.34,1.41-.35s1.36.38,1.45.28-.06-.21-.31-.4a2,2,0,0,0-1.16-.34,1.88,1.88,0,0,0-1.12.39A.44.44,0,0,0,355,168Z"
                    fill="#717272"
                />
                <path
                    id="Path_269"
                    data-name="Path 269"
                    d="M355.58,170.09a.63.63,0,0,0,.65.6.61.61,0,0,0,.62-.61.64.64,0,0,0-.65-.6.61.61,0,0,0-.62.61Z"
                    fill="#717272"
                />
                <path
                    id="Path_270"
                    data-name="Path 270"
                    d="M353,173.36a4.91,4.91,0,0,0-1.18-.14c-.18,0-.36,0-.4-.15a1,1,0,0,1,.09-.55l.46-1.43a25,25,0,0,0,1-3.73,25.572,25.572,0,0,0-1.3,3.64c-.15.5-.29,1-.43,1.43a1.06,1.06,0,0,0-.05.73.46.46,0,0,0,.31.25,1.22,1.22,0,0,0,.32,0,4,4,0,0,0,1.18-.05Z"
                    fill="#717272"
                />
                <path
                    id="Path_271"
                    data-name="Path 271"
                    d="M355.4,165.45c.07.17.7.05,1.44.1s1.37.22,1.46,0-.08-.24-.33-.39a2.42,2.42,0,0,0-1.09-.33,2.38,2.38,0,0,0-1.12.21C355.49,165.22,355.36,165.37,355.4,165.45Z"
                    fill="#717272"
                />
                <path
                    id="Path_272"
                    data-name="Path 272"
                    d="M348.07,165.89c.08.14.69,0,1.43,0s1.35.09,1.43-.06-.09-.19-.34-.31a2.81,2.81,0,0,0-2.18.06C348.15,165.69,348,165.82,348.07,165.89Z"
                    fill="#717272"
                />
                <path
                    id="Path_273"
                    data-name="Path 273"
                    d="M363,169.88c.08,0,3.16-1.14,3.25,2.06s-3.14,2.63-3.15,2.54S363,169.88,363,169.88Z"
                    fill="#e3e2e2"
                />
                <g id="Group_133" data-name="Group 133" opacity="0.5">
                    <path
                        id="Path_274"
                        data-name="Path 274"
                        d="M364.05,173.24a.259.259,0,0,1,.15.08.6.6,0,0,0,.42,0,1.38,1.38,0,0,0,.6-1.26,1.8,1.8,0,0,0-.17-.79.65.65,0,0,0-.44-.42.29.29,0,0,0-.32.16c0,.09,0,.16,0,.16s-.07,0,0-.18a.33.33,0,0,1,.12-.21.42.42,0,0,1,.3-.09.78.78,0,0,1,.6.48,2,2,0,0,1,.22.89,1.45,1.45,0,0,1-.78,1.4.56.56,0,0,1-.51-.07C364.06,173.32,364,173.25,364.05,173.24Z"
                        fill="#717272"
                    />
                </g>
                <path
                    id="Path_275"
                    data-name="Path 275"
                    d="M354,176.08c0-.08.6-.26,1-.84a3.351,3.351,0,0,0,.46-.83c.09-.23.17-.37.2-.36s0,.17,0,.42a2.471,2.471,0,0,1-.42.93,1.9,1.9,0,0,1-.83.61C354.14,176.11,354,176.11,354,176.08Z"
                    fill="#717272"
                />
                <path
                    id="Path_276"
                    data-name="Path 276"
                    d="M367.33,164.76A15.361,15.361,0,0,1,366.2,161a4.27,4.27,0,0,0-2.26-3h0a3.39,3.39,0,0,0-3.39.27,4.35,4.35,0,0,0-3.26-3.44,10.77,10.77,0,0,0-5.79.38,11.94,11.94,0,0,0-3.82,2.88,15.418,15.418,0,0,0-1.65,2l-1.47,4.34,1.18,2.3a5.066,5.066,0,0,0,.23.47h0l1,4.82c.08-1.31,0-5.88.13-7.19a7.31,7.31,0,0,0,5.25-2.34,8.78,8.78,0,0,1,2.27-2.24c1.25-.59,2.72-.13,4,.34l-.05-.05a6,6,0,0,1,1.79,1.33,18.13,18.13,0,0,0,.69,7.71c.11.38.44,1.15.8,1.29.72.29.92-.44,1.36-.82a2,2,0,0,1,1.31-.31,29.722,29.722,0,0,0,.92-3.3,2.89,2.89,0,0,0,1.34.1l-.4-1a1.76,1.76,0,0,0,.57.27.53.53,0,0,0,.55-.23A.9.9,0,0,0,367.33,164.76Z"
                    fill="#5b5b5b"
                />
                <g id="Group_134" data-name="Group 134" opacity="0.5">
                    <path
                        id="Path_277"
                        data-name="Path 277"
                        d="M359,158.78a3.866,3.866,0,0,1,.47.44,3.3,3.3,0,0,1,.69,1.55,6.26,6.26,0,0,1,.11,1.19c0,.43-.05.89-.09,1.37a12.764,12.764,0,0,0-.05,1.53,5.576,5.576,0,0,0,.09.81,1.7,1.7,0,0,0,.32.79.72.72,0,0,0,.66.23,1,1,0,0,0,.59-.33,2.36,2.36,0,0,0,.47-1.18h-.1a4,4,0,0,0,.56,1,1.35,1.35,0,0,0,.9.5.79.79,0,0,0,.48-.08.71.71,0,0,0,.33-.31.79.79,0,0,0,.1-.42.52.52,0,0,0-.14-.36h-.05a3,3,0,0,0,1,.77l.31.12a.31.31,0,0,0,.11,0h-.1l-.3-.14a3.3,3.3,0,0,1-1-.78h-.05a.6.6,0,0,1,0,.7.74.74,0,0,1-.3.28.78.78,0,0,1-.43.06,1.28,1.28,0,0,1-.84-.48,3.4,3.4,0,0,1-.53-1l-.07-.15v.16a2.42,2.42,0,0,1-.44,1.13.93.93,0,0,1-.54.29.6.6,0,0,1-.56-.19,1.6,1.6,0,0,1-.29-.74,5.31,5.31,0,0,1-.09-.79,12.629,12.629,0,0,1,0-1.52c0-.48.08-.94.08-1.38a6.332,6.332,0,0,0-.12-1.2,3.331,3.331,0,0,0-.74-1.57,1.749,1.749,0,0,0-.44-.3Z"
                    />
                </g>
                <g id="Group_135" data-name="Group 135" opacity="0.5">
                    <path
                        id="Path_278"
                        data-name="Path 278"
                        d="M344.55,163.13h0l.12.08a1,1,0,0,0,.19.13,2.324,2.324,0,0,0,.28.16,4.22,4.22,0,0,0,2,.38,5.37,5.37,0,0,0,2.83-1,9.17,9.17,0,0,0,2.45-2.76c.35-.56.63-1.14.94-1.67a6.061,6.061,0,0,1,1.06-1.4,3.24,3.24,0,0,1,1.36-.8,2.169,2.169,0,0,1,.71-.07,2.27,2.27,0,0,1,.65.13,2.67,2.67,0,0,1,1,.6,2.71,2.71,0,0,1,.52.69,3.833,3.833,0,0,1,.23.7v-.19a2.586,2.586,0,0,0-.17-.53,2.74,2.74,0,0,0-.52-.72,2.71,2.71,0,0,0-1-.62,2.35,2.35,0,0,0-.67-.15,2.291,2.291,0,0,0-.73.07,3.37,3.37,0,0,0-1.41.81,6.469,6.469,0,0,0-1.08,1.43c-.31.53-.6,1.11-.94,1.66a9.109,9.109,0,0,1-2.42,2.73,5.21,5.21,0,0,1-2.78,1,4.3,4.3,0,0,1-2-.34A5.764,5.764,0,0,1,344.55,163.13Z"
                    />
                </g>
                <path
                    id="Path_279"
                    data-name="Path 279"
                    d="M347.88,168.16c.09.09.64-.33,1.42-.34s1.36.38,1.44.28-.05-.22-.31-.4a1.94,1.94,0,0,0-2.28,0C347.91,167.94,347.83,168.11,347.88,168.16Z"
                    fill="#717272"
                />
                <path
                    id="Path_280"
                    data-name="Path 280"
                    d="M349.07,170.18a.64.64,0,0,0,.65.61.61.61,0,0,0,.62-.61.63.63,0,0,0-.65-.6.61.61,0,0,0-.62.6Z"
                    fill="#717272"
                />
                <path
                    id="Path_281"
                    data-name="Path 281"
                    d="M346.39,159.51a2,2,0,0,1-1.66.93,4.621,4.621,0,0,1-.69-.21c-.23.14-.18.92,0,1.14a3.489,3.489,0,0,0,.49.51,2.61,2.61,0,0,1-2.29-.09A4,4,0,0,0,344.6,165a1.4,1.4,0,0,0,1.29,0,1.63,1.63,0,0,0,.57-1,17.17,17.17,0,0,0,.57-4.28Z"
                    fill="#5b5b5b"
                />
                <path
                    id="Path_282"
                    data-name="Path 282"
                    d="M372.19,186.66a10.66,10.66,0,0,0-4.11-1.53l-5.08-1s-3.08,3.73-6.91,3.2-4.08-3.15-4.08-3.15-7.24,1.19-11.22,4.9a23.09,23.09,0,0,0,14.6,6.74c5.65.69,13.27-2.13,18.31-7.61C373.7,188.16,373.82,187.9,372.19,186.66Z"
                    fill="#717272"
                />
                <path
                    id="Path_283"
                    data-name="Path 283"
                    d="M379.18,174.89v-2.21c0-.29-.05-.61-.08-1a17.85,17.85,0,0,0-.32-2.33,21.34,21.34,0,0,0-2.09-6.08,22.38,22.38,0,0,0-14.32-11.42,21,21,0,0,0-2.78-.5c-.48-.05-1-.13-1.45-.15h-2.21l-.75.06c-.5.05-1,.08-1.51.15a23.271,23.271,0,0,0-3,.68,22.677,22.677,0,0,0-3,1.08c-.48.22-.95.49-1.43.73a13.3,13.3,0,0,0-1.4.84,24.9,24.9,0,0,0-2.65,2,25.6,25.6,0,0,0-2.34,2.43,21.5,21.5,0,0,0-3.56,5.9,22.08,22.08,0,0,0-.92,14,21.531,21.531,0,0,0,2.77,6.31,25.99,25.99,0,0,0,2,2.71,24.428,24.428,0,0,0,2.37,2.3,12.06,12.06,0,0,0,1.28,1c.45.31.88.63,1.33.92a22.719,22.719,0,0,0,2.81,1.46,24.655,24.655,0,0,0,2.9,1.06c.49.13,1,.23,1.47.34l.74.16a6.551,6.551,0,0,1,.74.1l1.46.17h1.45a20.4,20.4,0,0,0,2.83-.14A22.37,22.37,0,0,0,375.2,186a20.87,20.87,0,0,0,2.86-5.76,15.107,15.107,0,0,0,.62-2.27c.07-.33.15-.64.2-.92s.07-.54.1-.78c.06-.45.11-.8.14-1.05l.06-.36v.36l-.11,1.06c0,.24-.05.5-.08.78s-.12.6-.19.93a15.31,15.31,0,0,1-.59,2.3,21.22,21.22,0,0,1-2.83,5.82,22.148,22.148,0,0,1-18.66,9.8h-1.47l-1.49-.17a2.145,2.145,0,0,1-.75-.09l-.74-.17c-.49-.11-1-.2-1.5-.34a23.6,23.6,0,0,1-2.94-1.07,22,22,0,0,1-2.85-1.47c-.46-.29-.9-.62-1.35-.93a12.674,12.674,0,0,1-1.3-1,25.3,25.3,0,0,1-2.42-2.33,26.357,26.357,0,0,1-2-2.75,21.851,21.851,0,0,1-2.82-6.41,22.39,22.39,0,0,1,.92-14.21,21.9,21.9,0,0,1,3.63-6,24.066,24.066,0,0,1,2.38-2.46,25.664,25.664,0,0,1,2.69-2,12.113,12.113,0,0,1,1.42-.85c.49-.24,1-.51,1.46-.74a23.263,23.263,0,0,1,3-1.09,23.617,23.617,0,0,1,3.06-.68c.51-.07,1-.1,1.53-.15l.75-.06h2.25a13.609,13.609,0,0,1,1.46.15,21.292,21.292,0,0,1,2.82.52,22.5,22.5,0,0,1,14.42,11.61,21,21,0,0,1,2,6.15,14.7,14.7,0,0,1,.29,2.35c0,.34.06.65.07.94s0,.55,0,.79v1.07a2.455,2.455,0,0,1-.06.37Z"
                    fill="#5b5b5b"
                />
                <circle
                    id="Ellipse_8"
                    data-name="Ellipse 8"
                    cx="48.38"
                    cy="48.38"
                    r="48.38"
                    transform="translate(44.53 148.73)"
                    fill="#ff735d"
                />
                <circle
                    id="Ellipse_9"
                    data-name="Ellipse 9"
                    cx="48.38"
                    cy="48.38"
                    r="48.38"
                    transform="translate(44.53 148.73)"
                    fill="#717272"
                />
                <circle
                    id="Ellipse_10"
                    data-name="Ellipse 10"
                    cx="48.38"
                    cy="48.38"
                    r="48.38"
                    transform="translate(43.22 145.64)"
                    fill="#e3e2e2"
                />
                <circle
                    id="Ellipse_11"
                    data-name="Ellipse 11"
                    cx="37.64"
                    cy="37.64"
                    r="37.64"
                    transform="translate(53.96 156.38)"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_12"
                    data-name="Ellipse 12"
                    cx="26.48"
                    cy="26.48"
                    r="26.48"
                    transform="translate(54.156 194.022) rotate(-45)"
                    fill="#e3e2e2"
                />
                <circle
                    id="Ellipse_13"
                    data-name="Ellipse 13"
                    cx="13.97"
                    cy="13.97"
                    r="13.97"
                    transform="translate(71.848 194.022) rotate(-45)"
                    fill="#fff"
                />
                <path
                    id="Path_284"
                    data-name="Path 284"
                    d="M129.03,154.83l-1.31-10.32,10.5-11.24.76,11.14Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_285"
                    data-name="Path 285"
                    d="M151.58,146.62l-10.66-.87-10.68,10.28,10.69,1.14Z"
                    fill="#e3e2e2"
                />
                <path
                    id="Path_286"
                    data-name="Path 286"
                    d="M91.6,194.83l39.72-28.44a55,55,0,0,0-5-6.24l-34,32.9Z"
                    opacity="0.3"
                />
                <path
                    id="Path_287"
                    data-name="Path 287"
                    d="M140.56,142.25l-5,5.05-12,12.13L109.18,174,96.66,186.73c-2,2.06-4.15,4.06-6.1,6.18l-.09.09a1.3,1.3,0,0,0,1.84,1.84q2.49-2.52,5-5.05l12-12.13,14.42-14.61,12.52-12.69c2-2.05,4.15-4.05,6.1-6.18l.09-.09a1.3,1.3,0,0,0-1.84-1.84Z"
                    fill="#717272"
                />
            </g>
        </SVGIcon>
    );
}
